// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&family=Source+Sans+Pro:wght@300;400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*, *::before, *::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

* {
  scrollbar-width: none; /* ParaFirefox */
  -ms-overflow-style: none; /* Para Internet Explorer e Edge */
}

*::-webkit-scrollbar {
  width: 0px; /* Para Chrome, Safari, e Opera */
  display: none;
}

.m-0 {
  margin: 0;
  padding: 0;
}

.m-1 {
  margin: 8px;
}

.m-2 {
  margin: 12px;
}

.m-3 {
  margin: 16px;
}

.m-4 {
  margin: 24px;
}

.m-5 {
  margin: 32px;
}

.m-6 {
  margin: 40px;
}

.mt-0 {
  margin-top: 0;
}

.mt-1 {
  margin-top: 8px;
}

.mt-2 {
  margin-top: 12px;
}

.mt-3 {
  margin-top: 16px;
}

.mt-4 {
  margin-top: 24px;
}

.mt-5 {
  margin-top: 32px;
}

.mt-6 {
  margin-top: 40px;
}

.ml-1 {
  margin-left: 8px;
}

.ml-2 {
  margin-left: 12px;
}

.ml-3 {
  margin-left: 16px;
}

.ml-4 {
  margin-left: 24px;
}

.ml-5 {
  margin-left: 32px;
}

.ml-6 {
  margin-left: 40px;
}

.mr-1 {
  margin-right: 8px;
}

.mr-2 {
  margin-right: 12px;
}

.mr-3 {
  margin-right: 16px;
}

.mr-4 {
  margin-right: 24px;
}

.mr-5 {
  margin-right: 32px;
}

.mr-6 {
  margin-right: 40px;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-1 {
  margin-bottom: 8px;
}

.mb-2 {
  margin-bottom: 12px;
}

.mb-3 {
  margin-bottom: 16px;
}

.mb-4 {
  margin-bottom: 24px;
}

.mb-5 {
  margin-bottom: 32px;
}

.mb-6 {
  margin-bottom: 40px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.mx-2 {
  margin-left: 12px;
  margin-right: 12px;
}

.mx-3 {
  margin-left: 16px;
  margin-right: 16px;
}

.mx-4 {
  margin-left: 24px;
  margin-right: 24px;
}

.mx-5 {
  margin-left: 32px;
  margin-right: 32px;
}

.mx-6 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.my-2 {
  margin-top: 12px;
  margin-bottom: 12px;
}

.my-3 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.my-4 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.my-5 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.my-6 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-1 {
  padding: 8px;
}

.p-2 {
  padding: 12px;
}

.p-3 {
  padding: 16px;
}

.p-4 {
  padding: 24px;
}

.p-5 {
  padding: 32px;
}

.p-6 {
  padding: 40px;
}

.pt-1 {
  padding-top: 8px;
}

.pt-2 {
  padding-top: 12px;
}

.pt-3 {
  padding-top: 16px;
}

.pt-4 {
  padding-top: 24px;
}

.pt-5 {
  padding-top: 32px;
}

.pt-6 {
  padding-top: 40px;
}

.pt-7 {
  padding-top: 48px;
}

.pt-8 {
  padding-top: 56px;
}

.pt-9 {
  padding-top: 72px;
}

.pt-10 {
  padding-top: 96px;
}

.pt-11 {
  padding-top: 128px;
}

.pl-0 {
  padding-left: 0;
}

.pl-1 {
  padding-left: 8px;
}

.pl-2 {
  padding-left: 12px;
}

.pl-3 {
  padding-left: 16px;
}

.pl-4 {
  padding-left: 24px;
}

.pl-5 {
  padding-left: 32px;
}

.pl-6 {
  padding-left: 32px;
}

.pr-1 {
  padding-right: 8px;
}

.pr-2 {
  padding-right: 12px;
}

.pr-3 {
  padding-right: 16px;
}

.pr-4 {
  padding-right: 24px;
}

.pr-5 {
  padding-right: 32px;
}

.pr-6 {
  padding-right: 40px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pb-2 {
  padding-bottom: 12px;
}

.pb-3 {
  padding-bottom: 16px;
}

.pb-4 {
  padding-bottom: 24px;
}

.pb-5 {
  padding-bottom: 32px;
}

.pb-6 {
  padding-bottom: 40px;
}

.px-0 {
  padding-left: 0;
  padding-right: 0;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.px-2 {
  padding-left: 12px;
  padding-right: 12px;
}

.px-3 {
  padding-left: 16px;
  padding-right: 16px;
}

.px-4 {
  padding-left: 24px;
  padding-right: 24px;
}

.px-5 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.py-2 {
  padding-top: 12px;
  padding-bottom: 12px;
}

.py-3 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.py-4 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.py-5 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.color-green-light-3 {
  color: #C3FF94;
}

.color-green-light-2 {
  color: #AAF571;
}

.color-green-light-1 {
  color: #8CDB4F;
}

.color-green {
  color: #71C233;
}

.color-green-dark-1 {
  color: #58A81B;
}

.color-green-dark-2 {
  color: #438F09;
}

.color-green-dark-3 {
  color: #337500;
}

.light-green-2-medium {
  color: #88D4A5;
}

.light-black-green {
  color: #194248;
}

.color-white-light-3 {
  color: #FEFFFC;
}

.color-white-light-2 {
  color: #FBFCFA;
}

.color-white-light-1 {
  color: #232e3f;
}

.color-white {
  color: #dcdcdc;
}

.color-white-dark-1 {
  color: #D8DBE3;
}

.color-white-dark-2 {
  color: #E3EBDD;
}

.color-white-dark-3 {
  color: #DBE5D3;
}

.color-black-light-3 {
  color: #353D2E;
}

.color-black-light-2 {
  color: #2D3627;
}

.color-black-light-1 {
  color: #262E20;
}

.color-black {
  color: #1F2619;
}

.color-black-dark-1 {
  color: #181F13;
}

.color-black-dark-2 {
  color: #12170E;
}

.color-black-dark-3 {
  color: #0C0F09;
}

.color-gray-1 {
  color: #454446;
}

.color-gray-2 {
  color: #555456;
}

.color-gray-3 {
  color: #666566;
}

.color-gray-4 {
  color: #767576;
}

.color-gray-5 {
  color: #868587;
}

.color-gray-6 {
  color: #969597;
}

.color-gray-7 {
  color: #A6A6A7;
}

.auxiliary-red {
  color: #E7587D;
}

.auxiliary-red-light {
  color: #F1819E;
}

.auxiliary-red-dark {
  color: #C64869;
}

.auxiliary-blue {
  color: #5B89F4;
}

.auxiliary-blue-light {
  color: #83A7FB;
}

.auxiliary-blue-dark {
  color: #4A73D2;
}

.auxiliary-yellow {
  color: #F6BD18;
}

.auxiliary-yellow-light {
  color: #FED150;
}

.auxiliary-yellow-dark {
  color: #D5A210;
}

.container {
  max-width: 900px;
  margin: auto;
  padding: 96px 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
@media screen and (max-width: 960px) {
  .container {
    padding: 72px 24px;
    flex-direction: column;
  }
}

li {
  list-style: none;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: start;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-center-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-column {
  flex-direction: column;
}

.relative {
  position: relative;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-item-1 {
  flex: 1 1 360px;
}

.flex-item-2 {
  flex: 2 1 360px;
}

.flex-item-3 {
  flex: 3 1 360px;
}

.flex-item-4 {
  flex: 4 1 360px;
}

.flex-item-5 {
  flex: 5 1 360px;
}

.flex-item-auto {
  flex: 2 1 auto;
}

.w-auto {
  width: auto;
}

.w-100 {
  width: 100%;
}

.w-75 {
  width: 75%;
}

.w-50 {
  width: 50%;
}

.w-25 {
  width: 25%;
}

.hidden {
  overflow: hidden;
}

.height-100vh {
  height: 100vh;
}

.display-none {
  display: none;
}

.display-block {
  display: block;
}

.display-inline-block {
  display: inline-block;
}

.display-flex {
  display: flex;
}

.flex-1 {
  flex: 1 1;
}

.flex-end {
  align-items: end;
}

.display-inline-block {
  display: inline-block;
}

.visible {
  visibility: hidden;
}

.spacing-top-article {
  height: 150px;
}
@media screen and (max-width: 960px) {
  .spacing-top-article {
    height: 115px;
  }
}

.nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 40ch;
}

.col-2 {
  display: flex;
}

.cursor-pointer {
  cursor: pointer;
}

h1 {
  color: #12170E;
  font-family: "Rubik", sans-serif;
  font-size: 64px;
  line-height: 100%;
}
@media screen and (max-width: 960px) {
  h1 {
    font-family: "Rubik", sans-serif;
    font-size: 36px;
    line-height: 120%;
  }
}

h2 {
  color: #12170E;
  font-family: "Rubik", sans-serif;
  font-size: 52px;
  line-height: 110%;
}
@media screen and (max-width: 960px) {
  h2 {
    font-family: "Rubik", sans-serif;
    font-size: 36px;
    line-height: 120%;
  }
}

h3 {
  color: #12170E;
  font-family: "Rubik", sans-serif;
  font-size: 36px;
  line-height: 115%;
}
@media screen and (max-width: 960px) {
  h3 {
    font-family: "Rubik", sans-serif;
    font-size: 24px;
    line-height: 120%;
  }
}

h4 {
  color: #12170E;
  font-family: "Rubik", sans-serif;
  font-size: 24px;
  line-height: 130%;
}
@media screen and (max-width: 960px) {
  h4 {
    font-family: "Rubik", sans-serif;
    font-size: 18px;
    line-height: 130%;
  }
}

h5 {
  text-transform: uppercase;
  background: linear-gradient(180deg, #438F09 0%, #337500 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  line-height: 140%;
}
@media screen and (max-width: 960px) {
  h5 {
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    line-height: 150%;
  }
}

p {
  color: #767576;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  line-height: 130%;
}
@media screen and (max-width: 960px) {
  p {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 14px;
    line-height: 150%;
  }
}

.light p {
  color: #194248;
}

.bold {
  font-weight: bold;
  color: #2D3627;
}

span {
  color: #767576;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 150%;
}
@media screen and (max-width: 960px) {
  span {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 14px;
    line-height: 150%;
  }
}
span a {
  color: #C64869;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 150%;
}
span a:hover {
  color: #F1819E;
}

strong {
  font-weight: bold;
  color: red;
}

.small-warning {
  font-weight: 400;
  color: #C64869;
}

.text-align-center {
  text-align: center;
}

.text-align-right {
  text-align: right;
}

.text-align-left {
  text-align: left;
}

.text-wight-light {
  color: #767576;
  font-size: 12px;
  font-weight: 300;
}

.longText {
  font-size: 16px;
  line-height: 170%;
}
@media screen and (max-width: 960px) {
  .longText {
    font-size: 14px;
    line-height: 160%;
  }
}

.font-size-10 {
  font-size: 10px;
}

.font-size-12 {
  font-size: 12px;
}

.btn {
  display: inline-block;
  padding: 14px 28px;
  border-radius: 2px;
  border: 0;
  cursor: pointer;
  background: #dcdcdc;
  transition: background-color 0.3s ease; /* Adicione a transição desejada */
}
.btn:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.light .btn {
  border-radius: 8px;
  cursor: pointer;
  background: #88D4A5;
  border: 1px solid #88D4A5;
  transition: background-color 0.3s ease; /* Adicione a transição desejada */
}
.light .btn:hover {
  background-color: rgba(136, 212, 165, 0.8);
}

.btn-danger {
  border: 1px solid #E7587D;
  background-color: #F1819E;
}
.btn-danger p {
  color: white;
}
.btn-danger:hover {
  background-color: rgba(255, 0, 0, 0.8);
}

.btn-secondary {
  background-color: rgba(255, 255, 255, 0.2);
  color: #dcdcdc;
}
.btn-secondary p {
  color: rgba(255, 255, 255, 0.8);
}
.btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.light .btn-secondary {
  background-color: rgba(255, 255, 255, 0);
  color: #dcdcdc;
  border: 1px solid #88D4A5;
}
.light .btn-secondary p {
  color: rgba(25, 66, 72, 0.8);
}
.light .btn-secondary:hover {
  background-color: white;
}

a, .button-link {
  display: inline-block;
  text-decoration: none;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 150%;
  color: #dcdcdc;
  transition: 0.3s ease;
  cursor: pointer;
}
a:hover, .button-link:hover {
  opacity: 0.9;
}

.light a, .light .button-link {
  color: #194248;
}

.button-link {
  display: block;
  background-color: transparent;
  border: none;
  height: 100%;
  padding: 10px 24px;
}
.button-link:hover {
  color: rgba(255, 255, 255, 0.5);
}

.light .button-link:hover {
  color: rgba(25, 66, 72, 0.5);
}

.logo a {
  padding: 0;
}

.btn-icon {
  padding: 10px;
}

html {
  scroll-behavior: smooth;
}

body {
  width: 100%;
  height: 100vh;
  position: relative;
  scroll-behavior: smooth;
  overflow-x: hidden;
  background: linear-gradient(168.19deg, #020b18 7.54%, #0a172a 61.3%, #08172b 96.07%);
  background-attachment: fixed;
}

svg, img {
  display: block;
  width: 100%;
}

.border {
  border: 1px solid red;
}

header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  position: fixed;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0); /* Defina a cor de fundo inicialmente como transparente */
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  transition: background-color 0.3s; /* Adicione uma transição suave para a mudança de cor de fundo */
  cursor: pointer;
}

nav {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu {
  list-style: none;
  display: flex;
}
.menu li {
  margin-left: 24px;
}
@media screen and (max-width: 960px) {
  .menu {
    display: none;
  }
}

.logo {
  margin-left: 12px;
}
.logo img {
  height: 50px;
}

.bx {
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: 1px solid red;
  position: relative;
  display: none;
}
@media screen and (max-width: 960px) {
  .bx {
    display: block;
  }
}
.bx::after {
  content: "";
  width: 70%;
  height: 2px;
  display: block;
  position: absolute;
  top: 35%;
  left: 40%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  background-color: #FBFCFA;
}
.bx::before {
  content: "";
  width: 70%;
  height: 2px;
  display: block;
  position: absolute;
  top: 65%;
  left: 60%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  background-color: #FBFCFA;
}

.cta-desktop {
  display: block;
}
@media screen and (max-width: 960px) {
  .cta-desktop {
    display: none;
  }
}

.cta-mobile {
  display: none;
}
@media screen and (max-width: 960px) {
  .cta-mobile {
    display: block;
  }
}

.dropshadow {
  filter: drop-shadow(0px 16px 24px rgba(169, 80, 196, 0.25));
}

.icon-close {
  display: block;
  width: 20px;
  height: 20px;
}

/* Estilos para o ícone do hambúrguer */
.icon-menu {
  width: 30px;
  height: 20px;
  margin-left: 8px;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}
@media screen and (max-width: 960px) {
  .icon-menu {
    display: flex;
  }
}
.icon-menu:hover div {
  background-color: #71C233;
}

/* Estilos para as linhas do ícone */
.icon-menu div {
  width: 25px;
  height: 3px;
  border-radius: 3px;
  background-color: #dcdcdc;
  transition: 0.3s ease;
}

.light .icon-menu div {
  background-color: #868587;
}

.status {
  display: flex;
  align-items: center;
  margin-top: 4px;
}
.status .icon-ball {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 4px;
}
.status .icon-ball-red {
  background-color: #E7587D;
}
.status .icon-ball-orange {
  background-color: rgb(224, 100, 54);
}
.status .icon-ball-white {
  background-color: #dcdcdc;
}
.status .icon-ball-yellow {
  background-color: #F6BD18;
}
.status .icon-ball-green {
  background-color: #71C233;
}

.container-signin-signup {
  height: 100vh;
  max-width: 300px;
  padding: 12px;
}

.signin {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.signin .logo {
  margin: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.signin .logo img {
  height: 100%;
}
.signin form {
  width: 100%;
}

.light .container {
  display: flex;
  flex-direction: column;
}
.light .container a {
  padding-top: 12px;
  width: 100%;
  text-align: right;
}

.profile {
  width: 100%;
}
.profile h3 {
  font-weight: 400;
  color: #dcdcdc;
}
.profile .welcome p {
  color: #D8DBE3;
  opacity: 0.8;
}
.profile .welcome {
  max-width: 300px;
}
.profile .listaCongressos {
  margin-top: 12px;
}
.profile .profile-header {
  display: flex;
}
.profile .profile-header .profile-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 960px) {
  .profile .profile-header {
    display: block;
  }
  .profile .profile-header .profile-actions {
    margin-top: 12px;
    display: block;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 540px) {
  .profile .profile-header .btn {
    width: 100%;
    margin-bottom: 8px;
  }
  .profile .profile-header .btn p {
    text-align: center;
  }
}

li {
  margin-bottom: 8px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.2);
  color: #dcdcdc;
}
li a {
  padding: 12px 18px;
  width: 100%;
  height: 100%;
}
li:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.container-modal {
  width: 100%;
  position: absolute;
  z-index: 9999;
  justify-content: center;
  align-items: center;
  position: fixed;
  height: 100%;
  background: rgba(0, 0, 0, 0.49);
  -webkit-backdrop-filter: blur(17.8px);
          backdrop-filter: blur(17.8px);
  display: none;
  transition: all 0.3s ease;
}

.menu .header-modal {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.container-modal.show {
  display: flex;
}

.header-modal {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal {
  width: 500px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.modal .content {
  padding: 20px;
  height: 90vh;
  overflow-y: scroll;
}
.modal h3 {
  font-weight: 300;
  color: #dcdcdc;
}
.modal .modal-actions button, .modal .modal-actions a {
  width: 100%;
  margin-bottom: 12px;
}
.modal .modal-actions a {
  text-align: center;
}

.menu li {
  margin-left: 0;
}
.menu .content {
  padding-left: 8px;
  padding-right: 8px;
}
.menu a {
  text-align: center;
}

.light-form .modal .article h3 {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 400;
  margin-bottom: 12px;
}
@media screen and (max-width: 960px) {
  .light-form .modal .article h3 {
    font-size: 14px;
  }
}
.light-form .modal .article p {
  color: #FCFCFC;
  font-weight: 300;
  line-height: 17px;
  font-size: 14px;
  margin-bottom: 8px;
}
@media screen and (max-width: 960px) {
  .light-form .modal .article p {
    font-size: 12px;
  }
}
.light-form .modal .article .apresentacao {
  margin-top: 16px;
  border: 1px solid #88D4A5;
  border-radius: 4px;
}
.light-form .modal .article .apresentacao p {
  margin-bottom: 0;
  font-size: 14px;
}
.light-form .modal .article .apresentacao .content {
  padding: 8px 12px;
  height: 100%;
}
.light-form .modal .article .apresentacao .content span {
  font-weight: 700;
  color: #FCFCFC;
  font-size: 16px;
}
.light-form .modal .article .btn-checkin {
  background-color: #88D4A5;
  padding: 12px 16px;
  width: 100%;
  text-align: center;
  border-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.light-form .modal .article .btn-checkin p {
  margin: 0;
  font-weight: 400;
  color: #194248;
}

input {
  accent-color: #71C233;
}

label p {
  color: #dcdcdc;
}

li {
  cursor: pointer;
}

input, textarea {
  padding: 10px 0px;
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #969597;
  width: 100%;
  transition: 0.3s ease;
  color: #dcdcdc;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 150%;
}
input::placeholder, textarea::placeholder {
  color: rgba(220, 220, 220, 0.5);
  font-weight: 100;
}

.light-form input, textarea {
  border-bottom: 1px solid #dcdcdc;
  color: #767576;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 150%;
}
.light-form input::placeholder, textarea::placeholder {
  color: rgba(118, 117, 118, 0.8);
}

.light-form .modal input, textarea {
  color: #f1f1f1;
}
.light-form .modal input::placeholder, textarea::placeholder {
  color: rgba(220, 220, 220, 0.8);
}

.light-form .modal span {
  color: rgba(255, 255, 255, 0.6);
}

select {
  padding: 10px 0px;
  background-color: rgb(36, 42, 51);
  -webkit-background-color: rgb(36, 42, 51);
  border: 0;
  border-radius: 3px;
  border-bottom: 1px solid #969597;
  width: 100%;
  transition: 0.3s ease;
  color: #dcdcdc;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 150%;
}
select::placeholder {
  color: rgba(220, 220, 220, 0.5);
  font-weight: 100;
}

.light-form select {
  background-color: rgba(220, 220, 220, 0.1);
  -webkit-background-color: rgb(36, 42, 51);
}

input::placeholder {
  text-indent: 0;
}

input:focus, select:focus, textarea:focus {
  outline: none;
  border-bottom: 1px solid #8CDB4F;
}
input:focus::placeholder, select:focus::placeholder, textarea:focus::placeholder {
  font-weight: 500;
}

textarea {
  background-color: rgba(220, 220, 220, 0.1);
  border-radius: 3px;
  resize: none;
  height: 300px;
  padding: 10px 8px;
}

.error-input {
  border-bottom: 1px solid #F03D3D;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.input-container input {
  padding: 10px 32px;
}
.input-container .input-icon {
  position: absolute;
  width: 22px;
}
.input-container .input-icon svg path {
  transition: stroke 0.3s ease; /* Adicione a transição desejada */
}
.input-container:focus-within .input-icon svg path {
  stroke: #8CDB4F;
}

.checkbox input {
  width: 15px;
  margin-right: 4px;
  padding: 0;
}
.checkbox label {
  display: flex;
}

.input-people {
  align-items: end;
  justify-content: space-around;
}
.input-people .btn-add {
  display: inline-block;
  height: 40px;
  width: 40px;
  padding: 0;
  margin-left: 8px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slider {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
}
.slider span {
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  border: 1px solid #969597;
  background-color: rgb(36, 42, 51);
  border-radius: 3px;
  color: #dcdcdc;
}

.light-form .slider span {
  background-color: transparent;
  border: 1px solid #dcdcdc;
}

/* Estilizando o track do slider */
input[type=range] {
  width: 100%;
  height: 10px;
  border: none;
  border-radius: none;
  background-color: transparent;
  appearance: none; /* Removendo estilos padrão */
}

/* Estilizando a linha do track */
input[type=range]::-webkit-slider-runnable-track {
  height: 10px;
  border-radius: 5px;
  background-color: rgb(36, 42, 51);
}

.light-form input[type=range]::-webkit-slider-runnable-track {
  background-color: rgba(220, 220, 220, 0.2);
}

/* Estilizando o thumb (alça) do slider */
input[type=range]::-webkit-slider-thumb {
  width: 20px;
  height: 20px;
  background-color: #71C233;
  border-radius: 50%;
  cursor: pointer;
  appearance: none; /* Removendo estilos padrão */
  margin-top: -5px; /* Ajustando a posição vertical da alça */
}

.light-form input[type=range]::-webkit-slider-thumb {
  background-color: #8CDB4F;
}

.dashboard-filters {
  display: block;
  padding-bottom: 12px;
}
@media screen and (max-width: 540px) {
  .dashboard-filters {
    display: block;
  }
}

.label-options {
  display: flex;
  flex-wrap: wrap;
}
.label-options label {
  width: auto;
  border: 1px solid rgba(150, 149, 151, 0.8);
  border-radius: 3px;
  margin-right: 12px;
  padding: 24px 12px;
}
.label-options label:hover {
  border: 1px solid #71C233;
  background-color: rgba(220, 220, 220, 0.1);
  cursor: pointer;
}
@media screen and (max-width: 540px) {
  .label-options {
    display: block;
    width: 100%;
  }
  .label-options label {
    margin-right: 0;
  }
}

.filter-section {
  margin-bottom: 8px;
}

.filter-section label {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-bottom: 8px;
  margin-top: 8px;
  height: 20px;
}
.filter-section label input {
  width: 20px;
}
.filter-section label p {
  padding-left: 4px;
  color: #A6A6A7;
  line-height: 14px;
}

#dashboard select {
  margin-top: 8px;
  background-color: transparent;
  color: #194248;
  border: 1px solid #71C233;
  padding-left: 12px;
}

.body-admin {
  height: 100vh;
  overflow-x: hidden;
  display: flex;
}

.menu-admin {
  width: 150px;
  margin-top: 90px;
  height: calc(100vh - 83px);
  position: fixed;
}
.menu-admin li {
  background: none;
  border-radius: 0px;
  position: relative;
  margin-bottom: 0;
}
.menu-admin li::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(220, 220, 220, 0.3);
}
.menu-admin li a {
  padding-left: 32px;
  color: rgba(220, 220, 220, 0.4);
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.menu-admin li a:hover {
  background-color: rgba(220, 220, 220, 0.4);
  color: #dcdcdc;
}
.menu-admin .selected::before {
  background-color: #71C233;
}
.menu-admin .selected a {
  color: rgba(220, 220, 220, 0.8);
}
@media screen and (max-width: 960px) {
  .menu-admin {
    display: none;
  }
}

.light .menu-admin li::before {
  background-color: #dcdcdc;
}
.light .menu-admin a {
  color: #767576;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.light .menu-admin a:hover {
  background-color: rgba(150, 149, 151, 0.4);
  color: #194248;
}
.light .menu-admin .selected::before {
  background-color: #71C233;
}

.actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 960px) {
  .actions {
    display: block;
    width: 100%;
  }
  .actions .profile-actions {
    margin-top: 12px;
    display: block;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 540px) {
  .actions .btn {
    width: 100%;
    margin-bottom: 8px;
  }
  .actions .btn p {
    text-align: center;
  }
}

.container-admin {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  margin-top: 90px;
}
.container-admin h3 {
  color: rgba(220, 220, 220, 0.8);
  font-weight: 300;
}
.container-admin h4 {
  color: rgba(220, 220, 220, 0.8);
  font-weight: 300;
}
.container-admin .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 960px) {
  .container-admin {
    margin-top: 70px;
  }
  .container-admin .header {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
  .container-admin .header h4 {
    margin-top: 12px;
  }
}

.light .container-admin h4 {
  color: #194248;
}

.container-admin-menu {
  margin-left: 158px;
}
@media screen and (max-width: 960px) {
  .container-admin-menu {
    margin-left: 0;
  }
}

@media screen and (max-width: 960px) {
  .container-profile {
    margin-top: 85px;
  }
}

.boxes {
  padding-bottom: 16px;
  margin-top: 16px;
}

.box {
  width: 100%;
  margin-bottom: 12px;
  padding: 12px 16px;
  border: 1px solid rgba(150, 149, 151, 0.8);
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.box:hover {
  border: 1px solid #71C233;
  background-color: rgba(220, 220, 220, 0.1);
  cursor: pointer;
}
.box p {
  color: rgba(220, 220, 220, 0.8);
}
.box .btn {
  padding: 8px 16px;
}
@media screen and (max-width: 540px) {
  .box span {
    display: none;
  }
  .box .box-content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    width: 100%;
  }
}

.light .box {
  border: 1px solid #dcdcdc;
}
.light .box:hover {
  border: 1px solid #88D4A5;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}
.light .box p {
  color: #1F2619;
}
@media screen and (max-width: 540px) {
  .light .box span {
    display: none;
  }
  .light .box .box-content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    width: 100%;
  }
}

#headerAdmin .logo {
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerAdmin .logo a {
  padding-bottom: -5px;
}
#headerAdmin .logo svg {
  width: 39px;
  height: 50px;
}
@media screen and (max-width: 960px) {
  #headerAdmin .logo-img {
    display: none;
  }
  #headerAdmin .logo-img-block {
    display: flex;
  }
}
#headerAdmin .title {
  overflow: hidden;
  padding-left: 8px;
  padding-top: 32px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
@media screen and (max-width: 960px) {
  #headerAdmin .title {
    padding-top: 0;
    margin-left: 8px;
    padding-left: 0;
  }
}
#headerAdmin .title p {
  color: rgba(220, 220, 220, 0.5);
}
#headerAdmin .light p {
  color: #194248;
}

@media screen and (max-width: 960px) {
  .header-profile p {
    padding-top: 20px;
  }
  .header-profile svg {
    margin-top: 20px;
    margin-bottom: 30px;
  }
}

.nav-admin {
  margin-top: 12px;
}
.nav-admin ul {
  display: flex;
  position: relative;
}
.nav-admin ul::before {
  content: "";
  position: absolute;
  bottom: -0.5px;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background-color: #909DAE;
}
.nav-admin li {
  background: none;
  border-radius: 0px;
  position: relative;
  margin-bottom: 0;
}
.nav-admin li::before {
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  transition: all ease 0.4s;
}
.nav-admin li:hover::before {
  height: 2px;
  background-color: #71C233;
}
.nav-admin li a {
  color: rgba(220, 220, 220, 0.4);
}
.nav-admin .selected {
  color: rgba(220, 220, 220, 0.8);
}
.nav-admin .selected::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #71C233;
}

.success-message {
  color: white;
  padding: 8px 12px;
  border: 1px solid #71C233;
  background-color: gainsboro;
}

.incluir-avaliador {
  display: flex;
  align-items: end;
}
@media screen and (max-width: 540px) {
  .incluir-avaliador {
    display: block;
  }
  .incluir-avaliador .btn {
    margin-left: 0;
    margin-top: 8px;
  }
}

.dashboard-summary {
  display: flex;
}

.light h3 {
  color: #194248;
  font-weight: 400;
}

@media screen and (max-width: 540px) {
  .light .avaliador .box-content {
    overflow: visible;
    white-space: normal;
    display: block;
  }
}

.table {
  width: 100%;
  height: 300px;
  overflow-x: scroll;
  overflow-y: scroll;
}

table {
  border-spacing: 0;
  color: #f1f1f1;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  line-height: 130%;
}
@media screen and (max-width: 960px) {
  table {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 14px;
    line-height: 150%;
  }
}
table thead {
  background-color: rgba(255, 255, 255, 0.2);
}
table th {
  padding: 2px 16px;
}

.message {
  width: 100%;
}

.error-message {
  padding: 8px 18px;
  background: rgba(255, 0, 0, 0.56);
  border: 1px solid #F03D3D;
  border-radius: 2px;
}
.error-message p {
  color: #E3EBDD;
  font-weight: 300;
}

.light .error-message {
  background: rgba(255, 0, 0, 0.3);
}
.light .error-message p {
  color: #8a0101;
}

.success-message {
  padding: 8px 12px;
  border: 1px solid #71C233;
  background-color: rgba(220, 220, 220, 0.1);
}
.success-message p {
  color: rgb(192, 192, 192);
}

.general {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.general .col {
  display: block;
  flex: 1 1;
}
.general .col:not(:last-child) {
  margin-right: 16px; /* Adjust as needed */
}
.general .col .status {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.general .col .status h4 {
  font-size: 14px;
  margin-right: 16px;
}

.areas .status {
  display: flex;
  flex-wrap: wrap;
}
.areas .status .box {
  margin-right: 16px;
  flex: 1 1;
  width: 100%;
}
.areas .status .box h4 {
  color: red;
  display: block;
  width: auto;
}

.areas .box {
  border: 1px solid #ebaebe;
  flex: 1 1;
}
.areas .box h4 {
  font-size: 14px;
}

.posters, .posters-list {
  display: flex;
  width: 100%;
  overflow-y: scroll;
}
.posters .poster, .posters .item, .posters-list .poster, .posters-list .item {
  border: 1px solid #71C233;
  border-radius: 3px;
  padding: 4px 6px;
  margin: 4px;
}

.legenda {
  height: auto;
}

.reservado {
  background-color: none;
}

.conflito {
  background-color: #ebaebe;
}

.aguardando {
  background-color: #FED150;
}

.emAvaliacao {
  background-color: #88D4A5;
}

.posters {
  flex-wrap: wrap;
}

.posters-list {
  width: auto;
  height: auto;
}

.vazio {
  margin-top: 12px;
}
.vazio select {
  width: 160px;
}

#dashboard input {
  color: #194248;
}
#dashboard input::placeholder {
  color: #969597;
}

.container-dashboard {
  max-width: 850px;
}

.certificado-body {
  height: 100vh;
  background-color: #EDF2F2;
  justify-content: left;
  align-items: start;
  border: 1px solid #818181;
}
.certificado-body h4 {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #194248;
}
.certificado-body p {
  line-height: 19px;
}
.certificado-body .header {
  height: 160px;
  width: 100%;
  background-color: #FFF;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 40px;
}
.certificado-body .header svg {
  height: 114px;
  width: auto;
  margin-right: 18px;
}
.certificado-body .header .title {
  display: flex;
  align-items: center;
  margin-top: 60px;
}
.certificado-body .header .title p {
  margin-left: 24px;
  border-left: 2px solid #71C233;
  padding: 10px;
}
.certificado-body .section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 200px);
}
.certificado-body .content {
  padding: 40px;
  max-width: 800px;
}
.certificado-body .content h4 {
  font-size: 40px;
  margin-bottom: 20px;
  font-family: "Inter", sans-serif;
}
.certificado-body .content p {
  font-weight: 300;
}
.certificado-body .content p, .certificado-body .content span {
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
.certificado-body .content span {
  font-weight: 500;
}
.certificado-body .content .autenticacao {
  margin-top: 40px;
  display: flex;
}
.certificado-body .content .autenticacao p {
  font-size: 12px;
  margin-top: 8px;
  line-height: 14px;
}
.certificado-body .content .autenticacao span {
  margin-left: 10px;
  line-height: 12px;
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
.certificado-body .footer {
  padding: 0 40px;
}
.certificado-body .footer svg {
  height: 30px;
  width: auto;
  margin-right: 20px;
  margin-bottom: 20px;
}
.certificado-body .footer div {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: left;
}

@media print {
  .certificado-body {
    box-shadow: 0 0 0 1000px #EDF2F2 inset; /* cor para impressão */
  }
}
.avaliador .logo h3 {
  background-color: #88D4A5;
  font-size: 14px;
  width: 100%;
  padding: 8px 16px;
  text-align: center;
  border-radius: 4px;
  color: #194248;
}
.avaliador select {
  color: #194248;
}

.resumosHtml-body {
  background-color: #FFF;
  justify-content: left;
  align-items: start;
  border: 1px solid #818181;
}
.resumosHtml-body .page-break {
  page-break-before: always; /* ou page-break-after: always; */
}
.resumosHtml-body h4 {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #194248;
}
.resumosHtml-body p, .resumosHtml-body span {
  line-height: 19px;
  font-size: 12px;
}
.resumosHtml-body .header {
  height: 160px;
  width: 100%;
  background-color: #FFF;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 40px;
}
.resumosHtml-body .header svg {
  height: 114px;
  width: auto;
  margin-right: 18px;
}
.resumosHtml-body .header .title {
  display: flex;
  align-items: center;
  margin-top: 60px;
}
.resumosHtml-body .header .title p {
  margin-left: 24px;
  border-left: 2px solid #71C233;
  padding: 10px;
}
.resumosHtml-body .resumos {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  margin-bottom: 24px;
}
.resumosHtml-body .resumos h4 {
  margin-bottom: 12px;
}
.resumosHtml-body .section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 200px);
}
.resumosHtml-body .content {
  padding: 40px;
  max-width: 800px;
}
.resumosHtml-body .content h4 {
  font-size: 40px;
  margin-bottom: 20px;
  font-family: "Inter", sans-serif;
}
.resumosHtml-body .content p {
  font-weight: 300;
}
.resumosHtml-body .content p, .resumosHtml-body .content span {
  font-size: 10px;
  font-family: "Inter", sans-serif;
}
.resumosHtml-body .content span {
  font-weight: 500;
}
.resumosHtml-body .content .autenticacao {
  margin-top: 40px;
  display: flex;
}
.resumosHtml-body .content .autenticacao p {
  font-size: 10px;
  margin-top: 8px;
  line-height: 14px;
}
.resumosHtml-body .content .autenticacao span {
  margin-left: 10px;
  line-height: 12px;
  font-size: 10px;
  font-family: "Inter", sans-serif;
}
.resumosHtml-body .footer {
  padding: 0 40px;
}
.resumosHtml-body .footer svg {
  height: 30px;
  width: auto;
  margin-right: 20px;
  margin-bottom: 20px;
}
.resumosHtml-body .footer div {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: left;
}

@media print {
  .certificado-body {
    box-shadow: 0 0 0 1000px #EDF2F2 inset; /* cor para impressão */
  }
  .no-print {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/style.css","webpack://./src/css/style.scss","webpack://./src/css/partials/_spacing.scss","webpack://./src/css/partials/_colors.scss","webpack://./src/css/partials/_layout.scss","webpack://./src/css/partials/_typography.scss","webpack://./src/css/partials/_buttons.scss","webpack://./src/css/partials/_menu.scss","webpack://./src/css/partials/_icons.scss","webpack://./src/css/partials/_signin-singup.scss","webpack://./src/css/partials/_profile.scss","webpack://./src/css/partials/_list.scss","webpack://./src/css/partials/_modal.scss","webpack://./src/css/partials/_form.scss","webpack://./src/css/partials/_admin.scss","webpack://./src/css/partials/_table.scss","webpack://./src/css/partials/_notify.scss","webpack://./src/css/partials/_dashboard.scss","webpack://./src/css/partials/_certificado.scss","webpack://./src/css/partials/_avaliador.scss","webpack://./src/css/partials/_resumosHtml.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI,UAAA;EACA,SAAA;EACA,sBAAA;ADKJ;;ACHA;EACI,qBAAA,EAAA,gBAAA;EACA,wBAAA,EAAA,kCAAA;ADMJ;;ACJA;EACI,UAAA,EAAA,iCAAA;EACA,aAAA;ADOJ;;AENA;EACI,SAAA;EACA,UAAA;AFSJ;;AEPA;EACI,WAjBG;AF2BP;;AERA;EACI,YAnBG;AF8BP;;AETA;EACI,YArBG;AFiCP;;AEVA;EACI,YAvBG;AFoCP;;AEXA;EACI,YAzBG;AFuCP;;AEZA;EACI,YA3BG;AF0CP;;AEZA;EACI,aAAA;AFeJ;;AEbA;EACI,eAvCG;AFuDP;;AEdA;EACI,gBAzCG;AF0DP;;AEfA;EACI,gBA3CG;AF6DP;;AEhBA;EACI,gBA7CG;AFgEP;;AEjBA;EACI,gBA/CG;AFmEP;;AElBA;EACI,gBAjDG;AFsEP;;AEjBA;EACI,gBA3DG;AF+EP;;AElBA;EACI,iBA7DG;AFkFP;;AEnBA;EACI,iBA/DG;AFqFP;;AEpBA;EACI,iBAjEG;AFwFP;;AErBA;EACI,iBAnEG;AF2FP;;AEtBA;EACI,iBArEG;AF8FP;;AErBA;EACI,iBA/EG;AFuGP;;AEtBA;EACI,kBAjFG;AF0GP;;AEvBA;EACI,kBAnFG;AF6GP;;AExBA;EACI,kBArFG;AFgHP;;AEzBA;EACI,kBAvFG;AFmHP;;AE1BA;EACI,kBAzFG;AFsHP;;AE1BA;EACI,gBAAA;AF6BJ;;AE3BA;EACI,kBArGG;AFmIP;;AE5BA;EACI,mBAvGG;AFsIP;;AE7BA;EACI,mBAzGG;AFyIP;;AE9BA;EACI,mBA3GG;AF4IP;;AE/BA;EACI,mBA7GG;AF+IP;;AEhCA;EACI,mBA/GG;AFkJP;;AE/BA;EACI,gBAzHG;EA0HH,iBA1HG;AF4JP;;AEhCA;EACI,iBA5HG;EA6HH,kBA7HG;AFgKP;;AEjCA;EACI,iBA/HG;EAgIH,kBAhIG;AFoKP;;AElCA;EACI,iBAlIG;EAmIH,kBAnIG;AFwKP;;AEnCA;EACI,iBArIG;EAsIH,kBAtIG;AF4KP;;AEpCA;EACI,iBAxIG;EAyIH,kBAzIG;AFgLP;;AEpCA;EACI,eAlJG;EAmJH,kBAnJG;AF0LP;;AErCA;EACI,gBArJG;EAsJH,mBAtJG;AF8LP;;AEtCA;EACI,gBAxJG;EAyJH,mBAzJG;AFkMP;;AEvCA;EACI,gBA3JG;EA4JH,mBA5JG;AFsMP;;AExCA;EACI,gBA9JG;EA+JH,mBA/JG;AF0MP;;AEzCA;EACI,gBAjKG;EAkKH,mBAlKG;AF8MP;;AExCA;EACI,YA5KG;AFuNP;;AEzCA;EACI,aA9KG;AF0NP;;AE1CA;EACI,aAhLG;AF6NP;;AE3CA;EACI,aAlLG;AFgOP;;AE5CA;EACI,aApLG;AFmOP;;AE7CA;EACI,aAtLG;AFsOP;;AE7CA;EACI,gBA/LG;AF+OP;;AE9CA;EACI,iBAjMG;AFkPP;;AE/CA;EACI,iBAnMG;AFqPP;;AEhDA;EACI,iBArMG;AFwPP;;AEjDA;EACI,iBAvMG;AF2PP;;AElDA;EACI,iBAzMG;AF8PP;;AEnDA;EACI,iBA3MG;AFiQP;;AEpDA;EACI,iBA7MG;AFoQP;;AErDA;EACI,iBA/MG;AFuQP;;AEtDA;EACI,iBAjNI;AF0QR;;AEvDA;EACI,kBAnNI;AF6QR;;AEvDA;EACI,eAAA;AF0DJ;;AExDA;EACI,iBApOG;AF+RP;;AEzDA;EACI,kBAtOG;AFkSP;;AE1DA;EACI,kBAxOG;AFqSP;;AE3DA;EACI,kBA1OG;AFwSP;;AE5DA;EACI,kBA5OG;AF2SP;;AE7DA;EACI,kBA/OG;AF+SP;;AE7DA;EACI,kBAvPG;AFuTP;;AE9DA;EACI,mBAzPG;AF0TP;;AE/DA;EACI,mBA3PG;AF6TP;;AEhEA;EACI,mBA7PG;AFgUP;;AEjEA;EACI,mBA/PG;AFmUP;;AElEA;EACI,mBAjQG;AFsUP;;AElEA;EACI,mBA1QG;AF+UP;;AEnEA;EACI,oBA5QG;AFkVP;;AEpEA;EACI,oBA9QG;AFqVP;;AErEA;EACI,oBAhRG;AFwVP;;AEtEA;EACI,oBAlRG;AF2VP;;AEvEA;EACI,oBApRG;AF8VP;;AExEA;EACI,eAAA;EACA,gBAAA;AF2EJ;;AEzEA;EACI,iBAhSG;EAiSH,kBAjSG;AF6WP;;AE1EA;EACI,kBAnSG;EAoSH,mBApSG;AFiXP;;AE3EA;EACI,kBAtSG;EAuSH,mBAvSG;AFqXP;;AE5EA;EACI,kBAzSG;EA0SH,mBA1SG;AFyXP;;AE7EA;EACI,kBA5SG;EA6SH,mBA7SG;AF6XP;;AE7EA;EACI,gBArTG;EAsTH,mBAtTG;AFsYP;;AE9EA;EACI,iBAxTG;EAyTH,oBAzTG;AF0YP;;AE/EA;EACI,iBA3TG;EA4TH,oBA5TG;AF8YP;;AEhFA;EACI,iBA9TG;EA+TH,oBA/TG;AFkZP;;AEjFA;EACI,iBAjUG;EAkUH,oBAlUG;AFsZP;;AG7YA;EAAqB,cATA;AH0ZrB;;AGhZA;EAAqB,cATA;AH6ZrB;;AGnZA;EAAqB,cATA;AHgarB;;AGtZA;EAAa,cATA;AHmab;;AGzZA;EAAoB,cATA;AHsapB;;AG5ZA;EAAoB,cATA;AHyapB;;AG/ZA;EAAoB,cATA;AH4apB;;AGlaA;EAAsB,cATC;AH+avB;;AGraA;EAAmB,cATA;AHkbnB;;AGhaA;EAAqB,cAPA;AH2arB;;AGnaA;EAAqB,cAPA;AH8arB;;AGtaA;EAAqB,cAPA;AHibrB;;AGzaA;EAAa,cAPA;AHobb;;AG5aA;EAAoB,cAPA;AHubpB;;AG/aA;EAAoB,cAPA;AH0bpB;;AGlbA;EAAoB,cAPA;AH6bpB;;AG7aA;EAAqB,cAPA;AHwbrB;;AGhbA;EAAqB,cAPA;AH2brB;;AGnbA;EAAqB,cAPA;AH8brB;;AGtbA;EAAa,cAPA;AHicb;;AGzbA;EAAoB,cAPA;AHocpB;;AG5bA;EAAoB,cAPA;AHucpB;;AG/bA;EAAoB,cAPA;AH0cpB;;AGzbA;EAAc,cARN;AHqcR;;AG5bA;EAAc,cARN;AHwcR;;AG/bA;EAAc,cARN;AH2cR;;AGlcA;EAAc,cARN;AH8cR;;AGrcA;EAAc,cARN;AHidR;;AGxcA;EAAc,cARN;AHodR;;AG3cA;EAAc,cARN;AHudR;;AGzcA;EAAe,cAJC;AHidhB;;AG5cA;EAAqB,cAJC;AHodtB;;AG/cA;EAAoB,cAHC;AHsdrB;;AG9cA;EAAgB,cAHC;AHqdjB;;AGjdA;EAAsB,cAHC;AHwdvB;;AGpdA;EAAqB,cAHC;AH2dtB;;AGndA;EAAkB,cAHC;AH0dnB;;AGtdA;EAAwB,cAHC;AH6dzB;;AGzdA;EAAuB,cAHC;AHgexB;;AI5gBA;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AJ+gBJ;AIliBQ;EAYR;IASQ,kBAAA;IACA,sBAAA;EJihBN;AACF;;AI3gBA;EACI,gBAAA;AJ8gBJ;;AI3gBA;EACI,aAAA;EACA,2BAAA;EACA,kBAAA;AJ8gBJ;;AI5gBA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AJ+gBJ;;AI5gBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AJ+gBJ;;AI5gBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AJ+gBJ;;AI7gBA;EACI,sBAAA;AJghBJ;;AI9gBA;EACI,kBAAA;AJihBJ;;AI/gBA;EACI,eAAA;AJkhBJ;;AIhhBA;EACI,eAAA;AJmhBJ;;AIjhBA;EACI,eAAA;AJohBJ;;AIlhBA;EACI,eAAA;AJqhBJ;;AInhBA;EACI,eAAA;AJshBJ;;AIphBA;EACI,eAAA;AJuhBJ;;AIrhBA;EACI,cAAA;AJwhBJ;;AIthBA;EACI,WAAA;AJyhBJ;;AIvhBA;EACI,WAAA;AJ0hBJ;;AIxhBA;EACI,UAAA;AJ2hBJ;;AIzhBA;EACI,UAAA;AJ4hBJ;;AI1hBA;EACI,UAAA;AJ6hBJ;;AI3hBA;EACI,gBAAA;AJ8hBJ;;AI5hBA;EACI,aAAA;AJ+hBJ;;AI7hBA;EACI,aAAA;AJgiBJ;;AI9hBA;EACI,cAAA;AJiiBJ;;AI/hBA;EACI,qBAAA;AJkiBJ;;AIhiBA;EACI,aAAA;AJmiBJ;;AIjiBA;EACI,SAAA;AJoiBJ;;AIliBA;EACI,gBAAA;AJqiBJ;;AIniBA;EACI,qBAAA;AJsiBJ;;AIpiBA;EACI,kBAAA;AJuiBJ;;AIriBA;EACI,aAAA;AJwiBJ;AIxqBQ;EA+HR;IAGQ,aAAA;EJ0iBN;AACF;;AIviBA;EACI,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;AJ0iBF;;AIviBA;EACI,aAAA;AJ0iBJ;;AIxiBA;EACI,eAAA;AJ2iBJ;;AK9oBA;EACI,cFlCgB;EEvChB,gCAAA;EAGI,eAAA;EACA,iBAAA;ALytBR;AInsBQ;EC8CR;IAxEI,gCAAA;IAMI,eAAA;IACA,iBAAA;EL4tBN;AACF;;AKrpBA;EACI,cFzCgB;EEvChB,gCAAA;EAWI,eAAA;EACA,iBAAA;AL+tBR;AIjtBQ;ECqDR;IA/EI,gCAAA;IAcI,eAAA;IACA,iBAAA;ELkuBN;AACF;;AK5pBA;EACI,cFhDgB;EEvChB,gCAAA;EAmBI,eAAA;EACA,iBAAA;ALquBR;AI/tBQ;EC4DR;IAtFI,gCAAA;IAsBI,eAAA;IACA,iBAAA;ELwuBN;AACF;;AKnqBA;EACI,cFvDgB;EEvChB,gCAAA;EA2BI,eAAA;EACA,iBAAA;AL2uBR;AI7uBQ;ECmER;IA7FI,gCAAA;IA8BI,eAAA;IACA,iBAAA;EL8uBN;AACF;;AKzqBA;EACI,yBAAA;EACA,6DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,iBAAA;EA3GA,gCAAA;EAmCI,eAAA;EACA,iBAAA;ALsvBR;AIhwBQ;EC2ER;IArGI,gCAAA;IAsCI,eAAA;IACA,iBAAA;ELyvBN;AACF;;AK/qBA;EACI,cF/DI;EEPJ,0CAAA;EAWI,eAAA;EACA,iBAAA;AL+uBR;AI9wBQ;ECwFR;IArEI,0CAAA;IAsBI,eAAA;IACA,iBAAA;EL0uBN;AACF;;AKtrBA;EACI,cFlHe;AH2yBnB;;AKrrBA;EACI,iBAAA;EACA,cF7FiB;AHqxBrB;;AKtrBA;EACI,cF/EI;EEPJ,0CAAA;EAmBI,eAAA;EACA,iBAAA;AL8vBR;AIryBQ;ECwGR;IArFI,0CAAA;IAsBI,eAAA;IACA,iBAAA;ELiwBN;AACF;AK9rBI;EACI,cFrEa;EEvBjB,0CAAA;EAmBI,eAAA;EACA,iBAAA;AL2wBR;AKhsBI;EACI,cF3Ec;AH6wBtB;;AK/rBA;EACI,iBAAA;EACA,UAAA;ALksBJ;;AKhsBA;EACI,gBAAA;EACA,cFlFiB;AHqxBrB;;AKjsBA;EACI,kBAAA;ALosBJ;;AKlsBA;EACI,iBAAA;ALqsBJ;;AKnsBA;EACI,gBAAA;ALssBJ;;AKnsBA;EACI,cF/GI;EEgHJ,eAAA;EACA,gBAAA;ALssBJ;;AKpsBA;EACI,eAAA;EACA,iBAAA;ALusBJ;AIt1BQ;EC6IR;IAIQ,eAAA;IACA,iBAAA;ELysBN;AACF;;AKvsBA;EACI,eAAA;AL0sBJ;;AKxsBA;EACI,eAAA;AL2sBJ;;AMl4BA;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,mBHoBS;EGnBT,sCAAA,EAAA,kCAAA;ANq4BJ;AMp4BI;EACI,0CAAA;ANs4BR;;AMl4BA;EACI,kBJdG;EIeH,eAAA;EACA,mBHLmB;EGMnB,yBAAA;EACA,sCAAA,EAAA,kCAAA;ANq4BJ;AMp4BI;EACI,0CAAA;ANs4BR;;AMn4BA;EACI,yBAAA;EACA,yBH6CkB;AHy1BtB;AMr4BI;EACI,YAAA;ANu4BR;AMr4BI;EACI,sCAAA;ANu4BR;;AMh4BA;EACI,0CAAA;EACA,cHbS;AHg5Bb;AMl4BI;EACI,+BAAA;ANo4BR;AMj4BI;EACI,0CAAA;ANm4BR;;AM/3BA;EACI,wCAAA;EACA,cHzBS;EG6BT,yBAAA;AN+3BJ;AMl4BI;EACI,4BAAA;ANo4BR;AMj4BI;EACI,uBAAA;ANm4BR;;AM73BA;EACI,qBAAA;EACA,qBAAA;EDhBA,0CAAA;EAmBI,eAAA;EACA,iBAAA;ECFJ,cHzCS;EG0CT,qBAAA;EACA,eAAA;ANk4BJ;AMj4BI;EACI,YAAA;ANm4BR;;AM/3BA;EACI,cHhEe;AHk8BnB;;AM93BA;EACI,cAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;ANi4BJ;AMh4BI;EACI,+BAAA;ANk4BR;;AM53BI;EACI,4BAAA;AN+3BR;;AM33BA;EACI,UAAA;AN83BJ;;AM53BA;EACI,aAAA;AN+3BJ;;ACj9BA;EACI,uBAAA;ADo9BJ;;ACj9BA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oFAAA;EACA,4BAAA;ADo9BJ;;AC98BA;EACI,cAAA;EACA,WAAA;ADi9BJ;;AC98BA;EACI,qBAAA;ADi9BJ;;AO5/BA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA,EAAA,yDAAA;EACA,kCAAA;UAAA,0BAAA;EACA,iCAAA,EAAA,gEAAA;EACA,eAAA;AP+/BJ;;AO7/BA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;APggCJ;;AO9/BA;EACI,gBAAA;EACA,aAAA;APigCJ;AOhgCI;EACI,iBAAA;APkgCR;AI5/BQ;EGVR;IAOQ,aAAA;EPmgCN;AACF;;AOjgCA;EACI,iBL9BG;AFkiCP;AOngCI;EACI,YAAA;APqgCR;;AOlgCA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;APqgCJ;AIjhCQ;EGMR;IAQQ,cAAA;EPugCN;AACF;AOtgCI;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EAEA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;EACA,kBAAA;EAEA,yBJnCa;AHwiCrB;AOngCI;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EAEA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;EACA,kBAAA;EAEA,yBJlDa;AHojCrB;;AO9/BA;EACI,cAAA;APigCJ;AIljCQ;EGgDR;IAGQ,aAAA;EPmgCN;AACF;;AOhgCA;EACI,aAAA;APmgCJ;AI3jCQ;EGuDR;IAGQ,cAAA;EPqgCN;AACF;;AQ7lCA;EACI,2DAFQ;ARkmCZ;;AQ9lCA;EACI,cAAA;EACA,WAAA;EACA,YAAA;ARimCJ;;AQ9lCA,uCAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,gBNdG;EMeH,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;ARimCJ;AIrlCQ;EInBR;IAUQ,aAAA;ERkmCN;AACF;AQjmCI;EACI,yBLjBK;AHonCb;;AQ9lCA,oCAAA;AACA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBLRS;EKST,qBAAA;ARimCJ;;AQ/lCE;EACE,yBLmBI;AH+kCR;;AQhmCA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;ARmmCJ;AQlmCI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;ARomCR;AQlmCI;EACI,yBLkBQ;AHklChB;AQlmCI;EACI,mCAAA;ARomCR;AQlmCI;EACI,yBL/BK;AHmoCb;AQlmCI;EACI,yBLwBW;AH4kCnB;AQlmCI;EACI,yBLxDK;AH4pCb;;ASnqCA;EACI,aAAA;EACA,gBAAA;EACA,aPFG;AFwqCP;;ASpqCA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ATuqCJ;AStqCI;EACI,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ATwqCR;ASvqCQ;EACI,YAAA;ATyqCZ;AStqCI;EACI,WAAA;ATwqCR;;ASrqCA;EACI,aAAA;EACA,sBAAA;ATwqCJ;ASvqCI;EACI,iBP7BD;EO8BC,WAAA;EACA,iBAAA;ATyqCR;;AUxsCA;EACI,WAAA;AV2sCJ;AU1sCI;EACI,gBAAA;EACA,cPqBK;AHurCb;AU1sCI;EACI,cPmBY;EOlBZ,YAAA;AV4sCR;AU1sCI;EACI,gBAAA;AV4sCR;AU1sCI;EACI,gBRdD;AF0tCP;AU1sCI;EACI,aAAA;AV4sCR;AU1sCQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AV4sCZ;AIrsCQ;EMbJ;IASQ,cAAA;EV6sCV;EU5sCU;IAEI,gBR5BT;IQ6BS,cAAA;IACA,uBAAA;IACA,mBAAA;EV6sCd;AACF;AI1sCQ;EMCI;IACI,WAAA;IACA,kBRvCT;EFmvCL;EU3sCc;IACI,kBAAA;EV6sClB;AACF;;AWvvCA;EAMI,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cRiBS;AHouCb;AW7vCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AX+vCR;AWzvCI;EACI,0CAAA;AX2vCR;;AYtwCA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,+BAAA;EACA,qCAAA;UAAA,6BAAA;EACA,aAAA;EACA,yBAAA;AZywCJ;;AYrwCA;EACI,aAAA;EACA,uBAAA;EACA,mBVhBG;AFwxCP;;AYrwCA;EACI,aAAA;AZwwCJ;;AYpwCA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AZuwCJ;;AYrwCA;EACI,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AZwwCJ;AYvwCI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;AZywCR;AYpwCI;EACI,gBAAA;EACA,cTrBK;AH2xCb;AYnwCQ;EACI,WAAA;EACA,mBVnDL;AFwzCP;AYnwCQ;EACI,kBAAA;AZqwCZ;;AY/vCI;EACI,cAAA;AZkwCR;AYhwCI;EACI,iBVjED;EUkEC,kBVlED;AFo0CP;AYhwCI;EACI,kBAAA;AZkwCR;;AY9vCI;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EAIA,mBV/ED;AF60CP;AIhzCQ;EQ2CJ;IAKQ,eAAA;EZowCV;AACF;AYhwCI;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBVxFD;AF01CP;AI5zCQ;EQqDJ;IAOQ,eAAA;EZowCV;AACF;AYlwCI;EACI,gBV5FD;EU6FC,yBAAA;EACA,kBAAA;AZowCR;AYnwCQ;EACI,gBAAA;EACA,eAAA;AZqwCZ;AYnwCQ;EACI,iBAAA;EACA,YAAA;AZqwCZ;AYpwCY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AZswChB;AYlwCI;EACI,yBTrGe;ESsGf,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;AZowCR;AYnwCQ;EACI,SAAA;EACA,gBAAA;EACA,cT9GO;AHm3CnB;;Aa93CA;EACI,qBVKS;AH43Cb;;Aa/3CA;EACI,cVqBS;AH62Cb;;Aa93CA;EACI,eAAA;Abi4CJ;;Aa/3CA;EACI,iBAAA;EACA,6BAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,qBAAA;EACA,cVOS;EEuBT,0CAAA;EAmBI,eAAA;EACA,iBAAA;ALm1CR;Aap4CI;EACI,+BAAA;EACA,gBAAA;Abs4CR;;Aal4CA;EACI,gCAAA;EACA,cV4BI;EEPJ,0CAAA;EAmBI,eAAA;EACA,iBAAA;AL+1CR;Aav4CI;EACI,+BAAA;Aby4CR;;Aar4CA;EACI,cVyBI;AH+2CR;Aav4CI;EACI,+BAAA;Aby4CR;;Aap4CI;EACI,+BAAA;Abu4CR;;Aan4CA;EACI,iBAAA;EACA,iCAAA;EACA,yCAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,qBAAA;EACA,cV9BS;EEuBT,0CAAA;EAmBI,eAAA;EACA,iBAAA;AL43CR;Aax4CI;EACI,+BAAA;EACA,gBAAA;Ab04CR;;Aat4CA;EACI,0CAAA;EACA,yCAAA;Aby4CJ;;Aat4CA;EACI,cAAA;Aby4CJ;;Aat4CA;EACI,aAAA;EACA,gCAAA;Aby4CJ;Aax4CI;EACI,gBAAA;Ab04CR;;Aat4CA;EACI,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;Aby4CJ;;Aav4CA;EACI,gCAAA;Ab04CJ;;Aav4CA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;Ab04CJ;Aaz4CI;EACI,kBAAA;Ab24CR;Aaz4CI;EACI,kBAAA;EACA,WAAA;Ab24CR;Aav4CI;EACI,4BAAA,EAAA,kCAAA;Aby4CR;Aar4CI;EACI,eVxGa;AH++CrB;;Aaj4CI;EACI,WAAA;EACA,iBAAA;EACA,UAAA;Abo4CR;Aaj4CI;EACI,aAAA;Abm4CR;;Aah4CA;EACI,gBAAA;EACA,6BAAA;Abm4CJ;Aal4CI;EACI,qBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;Abo4CR;;Aa93CA;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;Abi4CJ;Aah4CI;EACI,gBXtJD;EWuJC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cVrIK;AHugDb;;Aa/3CA;EACI,6BAAA;EACA,yBAAA;Abk4CJ;;Aa/3CC,kCAAA;AACD;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA,EAAA,6BAAA;Abk4CJ;;Aa/3CA,iCAAA;AACA;EACI,YAAA;EACA,kBAAA;EACA,iCAAA;Abk4CJ;;Aah4CA;EACI,0CAAA;Abm4CJ;;Aah4CA,yCAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,yBVxLS;EUyLT,kBAAA;EACA,eAAA;EACA,gBAAA,EAAA,6BAAA;EACA,gBAAA,EAAA,yCAAA;Abm4CJ;;Aaj4CA;EACI,yBVhMiB;AHokDrB;;Aal4CA;EACI,cAAA;EACA,oBXzMG;AF8kDP;AI3iDQ;ESoKR;IAIQ,cAAA;Ebu4CN;AACF;;Aap4CA;EACI,aAAA;EACA,eAAA;Abu4CJ;Aat4CI;EACI,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBXtND;EWuNC,kBAAA;Abw4CR;Aav4CQ;EACI,yBAAA;EACA,0CAAA;EACA,eAAA;Aby4CZ;AIjkDQ;ES4KR;IAgBQ,cAAA;IACA,WAAA;Eby4CN;Eax4CM;IACI,eAAA;Eb04CV;AACF;;Aap4CA;EACI,kBX3OG;AFknDP;;Aar4CA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBXjPG;EWkPH,eXlPG;EWmPH,YAAA;Abw4CJ;Aav4CI;EACI,WAAA;Aby4CR;Aav4CI;EACI,iBAAA;EACA,cV9LA;EU+LA,iBAAA;Aby4CR;;Aan4CI;EACI,eXjQD;EWkQC,6BAAA;EACA,cVvPW;EUwPX,yBAAA;EACA,kBXpQD;AF0oDP;;Ac3oDA;EACI,aAAA;EACA,kBAAA;EACA,aAAA;Ad8oDJ;;Ac3oDA;EACI,YAAA;EACA,gBAAA;EACA,0BAAA;EAEA,eAAA;Ad6oDJ;Ac5oDI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;Ad8oDR;Ac5oDQ;EACI,WAAA;EACA,kBAAA;EACA,UZpBL;EYqBK,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;Ad8oDZ;Ac5oDQ;EACI,kBZ1BL;EY2BK,+BAAA;EACA,4BAAA;EACA,+BAAA;Ad8oDZ;Ac7oDY;EACI,0CAAA;EACA,cXVH;AHypDb;AczoDQ;EACI,yBXpCC;AH+qDb;AczoDQ;EACI,+BAAA;Ad2oDZ;AI3pDQ;EUxBR;IA4CQ,aAAA;Ed2oDN;AACF;;AcvoDQ;EACI,yBX9BC;AHwqDb;AcvoDI;EACI,cXJA;EWKA,4BAAA;EACA,+BAAA;AdyoDR;AcxoDQ;EACI,0CAAA;EACA,cXrDO;AH+rDnB;ActoDQ;EACI,yBX/DC;AHusDb;;AcnoDA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AdsoDJ;AItrDQ;EU6CR;IAKQ,cAAA;IACA,WAAA;EdwoDN;EcvoDM;IAEI,gBZnFL;IYoFK,cAAA;IACA,uBAAA;IACA,mBAAA;EdwoDV;AACF;AI5rDQ;EUwDA;IACI,WAAA;IACA,kBZ9FL;EFquDL;EctoDU;IACI,kBAAA;EdwoDd;AACF;;AcnoDA;EACI,WAAA;EACA,mBZtGG;EYuGH,kBZvGG;EYwGH,oBZxGG;EYyGH,gBAAA;AdsoDJ;AcpoDI;EACI,+BAAA;EACA,gBAAA;AdsoDR;AcpoDI;EACI,+BAAA;EACA,gBAAA;AdsoDR;AcpoDI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AdsoDR;AIhuDQ;EUwER;IAuBQ,gBAAA;EdqoDN;EcnoDM;IACI,aAAA;IACA,8BAAA;IACA,uBAAA;EdqoDV;EcnoDM;IACI,gBZpIL;EFywDL;AACF;;AchoDA;EACI,cXhIe;AHmwDnB;;AcjoDA;EACI,kBAAA;AdooDJ;AIrvDQ;EUgHR;IAIQ,cAAA;EdqoDN;AACF;;AI1vDQ;EUwHR;IAEQ,gBAAA;EdqoDN;AACF;;AcloDA;EACI,oBZ3JG;EY4JH,gBZ5JG;AFiyDP;;AcnoDA;EACI,WAAA;EACA,mBZjKG;EYkKH,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AdsoDJ;AcroDI;EACI,yBAAA;EACA,0CAAA;EACA,eAAA;AduoDR;AcroDI;EACI,+BAAA;AduoDR;AcroDI;EACI,iBAAA;AduoDR;AItxDQ;EUkJA;IACI,aAAA;EduoDV;EcroDM;IACI,gBAAA;IACA,mBAAA;IACA,uBAAA;IACA,qBAAA;IACA,WAAA;EduoDV;AACF;;AcloDA;EACI,yBAAA;AdqoDJ;AcnoDI;EACI,yBAAA;EACA,0CAAA;EACA,eAAA;AdqoDR;AcnoDI;EACI,cXpKK;AHyyDb;AI9yDQ;EU4KA;IACI,aAAA;EdqoDV;EcnoDM;IACI,gBAAA;IACA,mBAAA;IACA,uBAAA;IACA,qBAAA;IACA,WAAA;EdqoDV;AACF;;AchoDI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AdmoDR;AcjoDQ;EACI,oBAAA;AdmoDZ;AcjoDQ;EAEI,WAAA;EACA,YAAA;AdkoDZ;AI70DQ;EUgNA;IACI,aAAA;EdgoDV;Ec9nDM;IACI,aAAA;EdgoDV;AACF;Ac7nDI;EACI,gBAAA;EACA,iBZxPD;EYyPC,iBZrPD;EY2PC,oBAAA;EACA,4BAAA;EACA,qBAAA;Ad0nDR;AI71DQ;EUwNJ;IAKQ,cAAA;IACA,gBZ5PL;IY6PK,eAAA;EdooDV;AACF;AchoDQ;EACI,+BAAA;AdkoDZ;Ac7nDQ;EACI,cX7PO;AH43DnB;;AI12DQ;EUmPA;IACI,iBAAA;Ed2nDV;EcznDM;IAEI,gBAAA;IACA,mBAAA;Ed0nDV;AACF;;AcrnDA;EACI,gBZ7RG;AFq5DP;AcvnDI;EACI,aAAA;EACA,kBAAA;AdynDR;AcxnDQ;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;Ad0nDZ;AcvnDI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AdynDR;AcxnDQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;Ad0nDZ;ActnDY;EACI,WAAA;EACA,yBXrTH;AH66Db;AcpnDQ;EACI,+BAAA;AdsnDZ;AcjnDI;EAWM,+BAAA;AdymDV;AcnnDQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBXvUC;AH47Db;;Ac5mDA;EACI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;Ad+mDJ;;Ac5mDA;EACI,aAAA;EACA,gBAAA;Ad+mDJ;AI36DQ;EU0TR;IAIQ,cAAA;EdinDN;EchnDM;IACI,cAAA;IACA,eZrWL;EFu9DL;AACF;;Ac/mDA;EACI,aAAA;AdknDJ;;Ac/mDA;EACI,cXlWe;EWmWf,gBAAA;AdknDJ;;AI77DQ;EUgVA;IACI,iBAAA;IACA,mBAAA;IACA,cAAA;EdinDV;AACF;;Aez+DA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;Af4+DJ;;Ae1+DA;EACI,iBAAA;EACA,cZoDI;EEXJ,0CAAA;EAWI,eAAA;EACA,iBAAA;AL27DR;AI19DQ;EWxBR;IV2CI,0CAAA;IAsBI,eAAA;IACA,iBAAA;ELs7DN;AACF;Ael/DI;EACI,0CAAA;Afo/DR;Ael/DI;EACI,iBAAA;Afo/DR;;AgBrgEA;EACI,WAAA;AhBwgEJ;;AgBrgEA;EAMI,iBAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAAA;AhBmgEJ;AgB3gEI;EACI,cbsBY;EarBZ,gBAAA;AhB6gER;;AgBrgEA;EAII,gCAAA;AhBqgEJ;AgBxgEI;EACI,cAAA;AhB0gER;;AgBtgEA;EACI,iBAAA;EACA,yBAAA;EACA,0CAAA;AhBygEJ;AgBxgEI;EACI,yBAAA;AhB0gER;;AiBpiEA;EACI,aAAA;EACA,eAAA;EACA,WAAA;AjBuiEJ;AiBtiEI;EACI,cAAA;EACA,SAAA;AjBwiER;AiBviEQ;EACI,kBfNL,EeM2B,qBAAA;AjByiElC;AiBviEQ;EACI,WAAA;EACA,aAAA;EACA,eAAA;AjByiEZ;AiBxiEY;EACI,eAAA;EACA,kBfdT;AFwjEP;;AiBniEI;EACI,aAAA;EACA,eAAA;AjBsiER;AiBriEQ;EACI,kBfzBL;Ee0BK,SAAA;EACA,WAAA;AjBuiEZ;AiBtiEY;EACI,UAAA;EACA,cAAA;EACA,WAAA;AjBwiEhB;;AiBliEA;EAQI,yBAAA;EACA,SAAA;AjB8hEJ;AiBpiEQ;EACI,eAAA;AjBsiEZ;;AiB9hEA;EACI,aAAA;EACA,WAAA;EACA,kBAAA;AjBiiEJ;AiBhiEI;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AjBkiER;;AiB/hEA;EACI,YAAA;AjBkiEJ;;AiBhiEA;EACI,sBAAA;AjBmiEJ;;AiBjiEA;EACI,yBdEuB;AHkiE3B;;AiBliEA;EACI,yBdaqB;AHwhEzB;;AiBniEA;EACI,yBdhEmB;AHsmEvB;;AiBpiEA;EACI,eAAA;AjBuiEJ;;AiBriEA;EACI,WAAA;EACA,YAAA;AjBwiEJ;;AiBtiEA;EAII,gBfvFG;AF6nEP;AiBziEI;EACI,YAAA;AjB2iER;;AiBtiEA;EACI,cdhFe;AHynEnB;AiBxiEI;EACI,cdpCA;AH8kER;;AiBtiEA;EACI,gBAAA;AjByiEJ;;AkB1oEA;EACI,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;AlB6oEJ;AkB5oEI;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlB8oER;AkB5oEI;EACI,iBAAA;AlB8oER;AkB5oEI;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;AlB8oER;AkB7oEQ;EACI,aAAA;EACA,WAAA;EACA,kBAAA;AlB+oEZ;AkB7oEQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AlB+oEZ;AkB9oEY;EACI,iBhBhCT;EgBiCS,8BAAA;EACA,aAAA;AlBgpEhB;AkB5oEI;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,2BAAA;AlB8oER;AkB5oEI;EACI,aAAA;EACA,gBAAA;AlB8oER;AkB5oEQ;EACI,eAAA;EACA,mBAAA;EACA,gCAAA;AlB8oEZ;AkB5oEQ;EACI,gBAAA;AlB8oEZ;AkB5oEQ;EACI,eAAA;EACA,gCAAA;AlB8oEZ;AkB5oEQ;EACI,gBAAA;AlB8oEZ;AkB5oEQ;EACI,gBAAA;EACA,aAAA;AlB8oEZ;AkB7oEY;EACI,eAAA;EACA,eAAA;EACA,iBAAA;AlB+oEhB;AkB7oEY;EACI,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AlB+oEhB;AkB3oEI;EACI,eAAA;AlB6oER;AkB5oEQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AlB8oEZ;AkB5oEQ;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AlB8oEZ;;AkBvoEA;EACQ;IAEI,sCAAA,EAAA,uBAAA;ElByoEV;AACF;AmBjvEI;EACI,yBhBSe;EgBRf,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,chBIW;AH+uEnB;AmBjvEI;EACI,chBCW;AHkvEnB;;AoB5vEA;EAKI,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;ApB2vEJ;AoBjwEI;EACI,yBAAA,EAAA,iCAAA;ApBmwER;AoB7vEI;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cjBHW;AHkwEnB;AoB7vEI;EACI,iBAAA;EACA,eAAA;ApB+vER;AoB7vEI;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;ApB+vER;AoB9vEQ;EACI,aAAA;EACA,WAAA;EACA,kBAAA;ApBgwEZ;AoB9vEQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;ApBgwEZ;AoB/vEY;EACI,iBlBpCT;EkBqCS,8BAAA;EACA,aAAA;ApBiwEhB;AoB7vEI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBlB9CD;EkB+CC,mBlB/CD;AF8yEP;AoB9vEQ;EACI,mBlBnDL;AFmzEP;AoB7vEI;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,2BAAA;ApB+vER;AoB7vEI;EACI,aAAA;EACA,gBAAA;ApB+vER;AoB7vEQ;EACI,eAAA;EACA,mBAAA;EACA,gCAAA;ApB+vEZ;AoB7vEQ;EACI,gBAAA;ApB+vEZ;AoB7vEQ;EACI,eAAA;EACA,gCAAA;ApB+vEZ;AoB7vEQ;EACI,gBAAA;ApB+vEZ;AoB7vEQ;EACI,gBAAA;EACA,aAAA;ApB+vEZ;AoB9vEY;EACI,eAAA;EACA,eAAA;EACA,iBAAA;ApBgwEhB;AoB9vEY;EACI,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;ApBgwEhB;AoB5vEI;EACI,eAAA;ApB8vER;AoB7vEQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;ApB+vEZ;AoB7vEQ;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;ApB+vEZ;;AoBxvEA;EACQ;IAEI,sCAAA,EAAA,uBAAA;EpB0vEV;EoBxvEM;IACI,wBAAA;EpB0vEV;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&family=Source+Sans+Pro:wght@300;400&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500&display=swap\");\n*, *::before, *::after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n* {\n  scrollbar-width: none; /* ParaFirefox */\n  -ms-overflow-style: none; /* Para Internet Explorer e Edge */\n}\n\n*::-webkit-scrollbar {\n  width: 0px; /* Para Chrome, Safari, e Opera */\n  display: none;\n}\n\n.m-0 {\n  margin: 0;\n  padding: 0;\n}\n\n.m-1 {\n  margin: 8px;\n}\n\n.m-2 {\n  margin: 12px;\n}\n\n.m-3 {\n  margin: 16px;\n}\n\n.m-4 {\n  margin: 24px;\n}\n\n.m-5 {\n  margin: 32px;\n}\n\n.m-6 {\n  margin: 40px;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mt-1 {\n  margin-top: 8px;\n}\n\n.mt-2 {\n  margin-top: 12px;\n}\n\n.mt-3 {\n  margin-top: 16px;\n}\n\n.mt-4 {\n  margin-top: 24px;\n}\n\n.mt-5 {\n  margin-top: 32px;\n}\n\n.mt-6 {\n  margin-top: 40px;\n}\n\n.ml-1 {\n  margin-left: 8px;\n}\n\n.ml-2 {\n  margin-left: 12px;\n}\n\n.ml-3 {\n  margin-left: 16px;\n}\n\n.ml-4 {\n  margin-left: 24px;\n}\n\n.ml-5 {\n  margin-left: 32px;\n}\n\n.ml-6 {\n  margin-left: 40px;\n}\n\n.mr-1 {\n  margin-right: 8px;\n}\n\n.mr-2 {\n  margin-right: 12px;\n}\n\n.mr-3 {\n  margin-right: 16px;\n}\n\n.mr-4 {\n  margin-right: 24px;\n}\n\n.mr-5 {\n  margin-right: 32px;\n}\n\n.mr-6 {\n  margin-right: 40px;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.mb-1 {\n  margin-bottom: 8px;\n}\n\n.mb-2 {\n  margin-bottom: 12px;\n}\n\n.mb-3 {\n  margin-bottom: 16px;\n}\n\n.mb-4 {\n  margin-bottom: 24px;\n}\n\n.mb-5 {\n  margin-bottom: 32px;\n}\n\n.mb-6 {\n  margin-bottom: 40px;\n}\n\n.mx-1 {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.mx-2 {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n\n.mx-3 {\n  margin-left: 16px;\n  margin-right: 16px;\n}\n\n.mx-4 {\n  margin-left: 24px;\n  margin-right: 24px;\n}\n\n.mx-5 {\n  margin-left: 32px;\n  margin-right: 32px;\n}\n\n.mx-6 {\n  margin-left: 40px;\n  margin-right: 40px;\n}\n\n.my-1 {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.my-2 {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.my-3 {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.my-4 {\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n.my-5 {\n  margin-top: 32px;\n  margin-bottom: 32px;\n}\n\n.my-6 {\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n\n.p-1 {\n  padding: 8px;\n}\n\n.p-2 {\n  padding: 12px;\n}\n\n.p-3 {\n  padding: 16px;\n}\n\n.p-4 {\n  padding: 24px;\n}\n\n.p-5 {\n  padding: 32px;\n}\n\n.p-6 {\n  padding: 40px;\n}\n\n.pt-1 {\n  padding-top: 8px;\n}\n\n.pt-2 {\n  padding-top: 12px;\n}\n\n.pt-3 {\n  padding-top: 16px;\n}\n\n.pt-4 {\n  padding-top: 24px;\n}\n\n.pt-5 {\n  padding-top: 32px;\n}\n\n.pt-6 {\n  padding-top: 40px;\n}\n\n.pt-7 {\n  padding-top: 48px;\n}\n\n.pt-8 {\n  padding-top: 56px;\n}\n\n.pt-9 {\n  padding-top: 72px;\n}\n\n.pt-10 {\n  padding-top: 96px;\n}\n\n.pt-11 {\n  padding-top: 128px;\n}\n\n.pl-0 {\n  padding-left: 0;\n}\n\n.pl-1 {\n  padding-left: 8px;\n}\n\n.pl-2 {\n  padding-left: 12px;\n}\n\n.pl-3 {\n  padding-left: 16px;\n}\n\n.pl-4 {\n  padding-left: 24px;\n}\n\n.pl-5 {\n  padding-left: 32px;\n}\n\n.pl-6 {\n  padding-left: 32px;\n}\n\n.pr-1 {\n  padding-right: 8px;\n}\n\n.pr-2 {\n  padding-right: 12px;\n}\n\n.pr-3 {\n  padding-right: 16px;\n}\n\n.pr-4 {\n  padding-right: 24px;\n}\n\n.pr-5 {\n  padding-right: 32px;\n}\n\n.pr-6 {\n  padding-right: 40px;\n}\n\n.pb-1 {\n  padding-bottom: 8px;\n}\n\n.pb-2 {\n  padding-bottom: 12px;\n}\n\n.pb-3 {\n  padding-bottom: 16px;\n}\n\n.pb-4 {\n  padding-bottom: 24px;\n}\n\n.pb-5 {\n  padding-bottom: 32px;\n}\n\n.pb-6 {\n  padding-bottom: 40px;\n}\n\n.px-0 {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.px-1 {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.px-2 {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.px-3 {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.px-4 {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.px-5 {\n  padding-left: 32px;\n  padding-right: 32px;\n}\n\n.py-1 {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.py-2 {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.py-3 {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n.py-4 {\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n.py-5 {\n  padding-top: 32px;\n  padding-bottom: 32px;\n}\n\n.color-green-light-3 {\n  color: #C3FF94;\n}\n\n.color-green-light-2 {\n  color: #AAF571;\n}\n\n.color-green-light-1 {\n  color: #8CDB4F;\n}\n\n.color-green {\n  color: #71C233;\n}\n\n.color-green-dark-1 {\n  color: #58A81B;\n}\n\n.color-green-dark-2 {\n  color: #438F09;\n}\n\n.color-green-dark-3 {\n  color: #337500;\n}\n\n.light-green-2-medium {\n  color: #88D4A5;\n}\n\n.light-black-green {\n  color: #194248;\n}\n\n.color-white-light-3 {\n  color: #FEFFFC;\n}\n\n.color-white-light-2 {\n  color: #FBFCFA;\n}\n\n.color-white-light-1 {\n  color: #232e3f;\n}\n\n.color-white {\n  color: #dcdcdc;\n}\n\n.color-white-dark-1 {\n  color: #D8DBE3;\n}\n\n.color-white-dark-2 {\n  color: #E3EBDD;\n}\n\n.color-white-dark-3 {\n  color: #DBE5D3;\n}\n\n.color-black-light-3 {\n  color: #353D2E;\n}\n\n.color-black-light-2 {\n  color: #2D3627;\n}\n\n.color-black-light-1 {\n  color: #262E20;\n}\n\n.color-black {\n  color: #1F2619;\n}\n\n.color-black-dark-1 {\n  color: #181F13;\n}\n\n.color-black-dark-2 {\n  color: #12170E;\n}\n\n.color-black-dark-3 {\n  color: #0C0F09;\n}\n\n.color-gray-1 {\n  color: #454446;\n}\n\n.color-gray-2 {\n  color: #555456;\n}\n\n.color-gray-3 {\n  color: #666566;\n}\n\n.color-gray-4 {\n  color: #767576;\n}\n\n.color-gray-5 {\n  color: #868587;\n}\n\n.color-gray-6 {\n  color: #969597;\n}\n\n.color-gray-7 {\n  color: #A6A6A7;\n}\n\n.auxiliary-red {\n  color: #E7587D;\n}\n\n.auxiliary-red-light {\n  color: #F1819E;\n}\n\n.auxiliary-red-dark {\n  color: #C64869;\n}\n\n.auxiliary-blue {\n  color: #5B89F4;\n}\n\n.auxiliary-blue-light {\n  color: #83A7FB;\n}\n\n.auxiliary-blue-dark {\n  color: #4A73D2;\n}\n\n.auxiliary-yellow {\n  color: #F6BD18;\n}\n\n.auxiliary-yellow-light {\n  color: #FED150;\n}\n\n.auxiliary-yellow-dark {\n  color: #D5A210;\n}\n\n.container {\n  max-width: 900px;\n  margin: auto;\n  padding: 96px 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n}\n@media screen and (max-width: 960px) {\n  .container {\n    padding: 72px 24px;\n    flex-direction: column;\n  }\n}\n\nli {\n  list-style: none;\n}\n\n.flex-start {\n  display: flex;\n  justify-content: flex-start;\n  align-items: start;\n}\n\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-center-space-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.relative {\n  position: relative;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.flex-item-1 {\n  flex: 1 1 360px;\n}\n\n.flex-item-2 {\n  flex: 2 1 360px;\n}\n\n.flex-item-3 {\n  flex: 3 1 360px;\n}\n\n.flex-item-4 {\n  flex: 4 1 360px;\n}\n\n.flex-item-5 {\n  flex: 5 1 360px;\n}\n\n.flex-item-auto {\n  flex: 2 1 auto;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.w-75 {\n  width: 75%;\n}\n\n.w-50 {\n  width: 50%;\n}\n\n.w-25 {\n  width: 25%;\n}\n\n.hidden {\n  overflow: hidden;\n}\n\n.height-100vh {\n  height: 100vh;\n}\n\n.display-none {\n  display: none;\n}\n\n.display-block {\n  display: block;\n}\n\n.display-inline-block {\n  display: inline-block;\n}\n\n.display-flex {\n  display: flex;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-end {\n  align-items: end;\n}\n\n.display-inline-block {\n  display: inline-block;\n}\n\n.visible {\n  visibility: hidden;\n}\n\n.spacing-top-article {\n  height: 150px;\n}\n@media screen and (max-width: 960px) {\n  .spacing-top-article {\n    height: 115px;\n  }\n}\n\n.nowrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 40ch;\n}\n\n.col-2 {\n  display: flex;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\nh1 {\n  color: #12170E;\n  font-family: \"Rubik\", sans-serif;\n  font-size: 64px;\n  line-height: 100%;\n}\n@media screen and (max-width: 960px) {\n  h1 {\n    font-family: \"Rubik\", sans-serif;\n    font-size: 36px;\n    line-height: 120%;\n  }\n}\n\nh2 {\n  color: #12170E;\n  font-family: \"Rubik\", sans-serif;\n  font-size: 52px;\n  line-height: 110%;\n}\n@media screen and (max-width: 960px) {\n  h2 {\n    font-family: \"Rubik\", sans-serif;\n    font-size: 36px;\n    line-height: 120%;\n  }\n}\n\nh3 {\n  color: #12170E;\n  font-family: \"Rubik\", sans-serif;\n  font-size: 36px;\n  line-height: 115%;\n}\n@media screen and (max-width: 960px) {\n  h3 {\n    font-family: \"Rubik\", sans-serif;\n    font-size: 24px;\n    line-height: 120%;\n  }\n}\n\nh4 {\n  color: #12170E;\n  font-family: \"Rubik\", sans-serif;\n  font-size: 24px;\n  line-height: 130%;\n}\n@media screen and (max-width: 960px) {\n  h4 {\n    font-family: \"Rubik\", sans-serif;\n    font-size: 18px;\n    line-height: 130%;\n  }\n}\n\nh5 {\n  text-transform: uppercase;\n  background: linear-gradient(180deg, #438F09 0%, #337500 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n  font-family: \"Rubik\", sans-serif;\n  font-size: 18px;\n  line-height: 140%;\n}\n@media screen and (max-width: 960px) {\n  h5 {\n    font-family: \"Rubik\", sans-serif;\n    font-size: 16px;\n    line-height: 150%;\n  }\n}\n\np {\n  color: #767576;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 16px;\n  line-height: 130%;\n}\n@media screen and (max-width: 960px) {\n  p {\n    font-family: \"Source Sans Pro\", sans-serif;\n    font-size: 14px;\n    line-height: 150%;\n  }\n}\n\n.light p {\n  color: #194248;\n}\n\n.bold {\n  font-weight: bold;\n  color: #2D3627;\n}\n\nspan {\n  color: #767576;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  line-height: 150%;\n}\n@media screen and (max-width: 960px) {\n  span {\n    font-family: \"Source Sans Pro\", sans-serif;\n    font-size: 14px;\n    line-height: 150%;\n  }\n}\nspan a {\n  color: #C64869;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  line-height: 150%;\n}\nspan a:hover {\n  color: #F1819E;\n}\n\nstrong {\n  font-weight: bold;\n  color: red;\n}\n\n.small-warning {\n  font-weight: 400;\n  color: #C64869;\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.text-align-right {\n  text-align: right;\n}\n\n.text-align-left {\n  text-align: left;\n}\n\n.text-wight-light {\n  color: #767576;\n  font-size: 12px;\n  font-weight: 300;\n}\n\n.longText {\n  font-size: 16px;\n  line-height: 170%;\n}\n@media screen and (max-width: 960px) {\n  .longText {\n    font-size: 14px;\n    line-height: 160%;\n  }\n}\n\n.font-size-10 {\n  font-size: 10px;\n}\n\n.font-size-12 {\n  font-size: 12px;\n}\n\n.btn {\n  display: inline-block;\n  padding: 14px 28px;\n  border-radius: 2px;\n  border: 0;\n  cursor: pointer;\n  background: #dcdcdc;\n  transition: background-color 0.3s ease; /* Adicione a transição desejada */\n}\n.btn:hover {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.light .btn {\n  border-radius: 8px;\n  cursor: pointer;\n  background: #88D4A5;\n  border: 1px solid #88D4A5;\n  transition: background-color 0.3s ease; /* Adicione a transição desejada */\n}\n.light .btn:hover {\n  background-color: rgba(136, 212, 165, 0.8);\n}\n\n.btn-danger {\n  border: 1px solid #E7587D;\n  background-color: #F1819E;\n}\n.btn-danger p {\n  color: white;\n}\n.btn-danger:hover {\n  background-color: rgba(255, 0, 0, 0.8);\n}\n\n.btn-secondary {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #dcdcdc;\n}\n.btn-secondary p {\n  color: rgba(255, 255, 255, 0.8);\n}\n.btn-secondary:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.light .btn-secondary {\n  background-color: rgba(255, 255, 255, 0);\n  color: #dcdcdc;\n  border: 1px solid #88D4A5;\n}\n.light .btn-secondary p {\n  color: rgba(25, 66, 72, 0.8);\n}\n.light .btn-secondary:hover {\n  background-color: white;\n}\n\na, .button-link {\n  display: inline-block;\n  text-decoration: none;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  line-height: 150%;\n  color: #dcdcdc;\n  transition: 0.3s ease;\n  cursor: pointer;\n}\na:hover, .button-link:hover {\n  opacity: 0.9;\n}\n\n.light a, .light .button-link {\n  color: #194248;\n}\n\n.button-link {\n  display: block;\n  background-color: transparent;\n  border: none;\n  height: 100%;\n  padding: 10px 24px;\n}\n.button-link:hover {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.light .button-link:hover {\n  color: rgba(25, 66, 72, 0.5);\n}\n\n.logo a {\n  padding: 0;\n}\n\n.btn-icon {\n  padding: 10px;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n  background: linear-gradient(168.19deg, #020b18 7.54%, #0a172a 61.3%, #08172b 96.07%);\n  background-attachment: fixed;\n}\n\nsvg, img {\n  display: block;\n  width: 100%;\n}\n\n.border {\n  border: 1px solid red;\n}\n\nheader {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 70px;\n  position: fixed;\n  z-index: 999;\n  background-color: rgba(255, 255, 255, 0); /* Defina a cor de fundo inicialmente como transparente */\n  -webkit-backdrop-filter: blur(6px);\n          backdrop-filter: blur(6px);\n  transition: background-color 0.3s; /* Adicione uma transição suave para a mudança de cor de fundo */\n  cursor: pointer;\n}\n\nnav {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.menu {\n  list-style: none;\n  display: flex;\n}\n.menu li {\n  margin-left: 24px;\n}\n@media screen and (max-width: 960px) {\n  .menu {\n    display: none;\n  }\n}\n\n.logo {\n  margin-left: 12px;\n}\n.logo img {\n  height: 50px;\n}\n\n.bx {\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  border: 1px solid red;\n  position: relative;\n  display: none;\n}\n@media screen and (max-width: 960px) {\n  .bx {\n    display: block;\n  }\n}\n.bx::after {\n  content: \"\";\n  width: 70%;\n  height: 2px;\n  display: block;\n  position: absolute;\n  top: 35%;\n  left: 40%;\n  transform: translate(-50%, -50%);\n  border-radius: 2px;\n  background-color: #FBFCFA;\n}\n.bx::before {\n  content: \"\";\n  width: 70%;\n  height: 2px;\n  display: block;\n  position: absolute;\n  top: 65%;\n  left: 60%;\n  transform: translate(-50%, -50%);\n  border-radius: 2px;\n  background-color: #FBFCFA;\n}\n\n.cta-desktop {\n  display: block;\n}\n@media screen and (max-width: 960px) {\n  .cta-desktop {\n    display: none;\n  }\n}\n\n.cta-mobile {\n  display: none;\n}\n@media screen and (max-width: 960px) {\n  .cta-mobile {\n    display: block;\n  }\n}\n\n.dropshadow {\n  filter: drop-shadow(0px 16px 24px rgba(169, 80, 196, 0.25));\n}\n\n.icon-close {\n  display: block;\n  width: 20px;\n  height: 20px;\n}\n\n/* Estilos para o ícone do hambúrguer */\n.icon-menu {\n  width: 30px;\n  height: 20px;\n  margin-left: 8px;\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n}\n@media screen and (max-width: 960px) {\n  .icon-menu {\n    display: flex;\n  }\n}\n.icon-menu:hover div {\n  background-color: #71C233;\n}\n\n/* Estilos para as linhas do ícone */\n.icon-menu div {\n  width: 25px;\n  height: 3px;\n  border-radius: 3px;\n  background-color: #dcdcdc;\n  transition: 0.3s ease;\n}\n\n.light .icon-menu div {\n  background-color: #868587;\n}\n\n.status {\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n}\n.status .icon-ball {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin-right: 4px;\n}\n.status .icon-ball-red {\n  background-color: #E7587D;\n}\n.status .icon-ball-orange {\n  background-color: rgb(224, 100, 54);\n}\n.status .icon-ball-white {\n  background-color: #dcdcdc;\n}\n.status .icon-ball-yellow {\n  background-color: #F6BD18;\n}\n.status .icon-ball-green {\n  background-color: #71C233;\n}\n\n.container-signin-signup {\n  height: 100vh;\n  max-width: 300px;\n  padding: 12px;\n}\n\n.signin {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.signin .logo {\n  margin: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.signin .logo img {\n  height: 100%;\n}\n.signin form {\n  width: 100%;\n}\n\n.light .container {\n  display: flex;\n  flex-direction: column;\n}\n.light .container a {\n  padding-top: 12px;\n  width: 100%;\n  text-align: right;\n}\n\n.profile {\n  width: 100%;\n}\n.profile h3 {\n  font-weight: 400;\n  color: #dcdcdc;\n}\n.profile .welcome p {\n  color: #D8DBE3;\n  opacity: 0.8;\n}\n.profile .welcome {\n  max-width: 300px;\n}\n.profile .listaCongressos {\n  margin-top: 12px;\n}\n.profile .profile-header {\n  display: flex;\n}\n.profile .profile-header .profile-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@media screen and (max-width: 960px) {\n  .profile .profile-header {\n    display: block;\n  }\n  .profile .profile-header .profile-actions {\n    margin-top: 12px;\n    display: block;\n    justify-content: center;\n    align-items: center;\n  }\n}\n@media screen and (max-width: 540px) {\n  .profile .profile-header .btn {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  .profile .profile-header .btn p {\n    text-align: center;\n  }\n}\n\nli {\n  margin-bottom: 8px;\n  border-radius: 2px;\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #dcdcdc;\n}\nli a {\n  padding: 12px 18px;\n  width: 100%;\n  height: 100%;\n}\nli:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.container-modal {\n  width: 100%;\n  position: absolute;\n  z-index: 9999;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.49);\n  -webkit-backdrop-filter: blur(17.8px);\n          backdrop-filter: blur(17.8px);\n  display: none;\n  transition: all 0.3s ease;\n}\n\n.menu .header-modal {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.container-modal.show {\n  display: flex;\n}\n\n.header-modal {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal {\n  width: 500px;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.modal .content {\n  padding: 20px;\n  height: 90vh;\n  overflow-y: scroll;\n}\n.modal h3 {\n  font-weight: 300;\n  color: #dcdcdc;\n}\n.modal .modal-actions button, .modal .modal-actions a {\n  width: 100%;\n  margin-bottom: 12px;\n}\n.modal .modal-actions a {\n  text-align: center;\n}\n\n.menu li {\n  margin-left: 0;\n}\n.menu .content {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.menu a {\n  text-align: center;\n}\n\n.light-form .modal .article h3 {\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: 400;\n  margin-bottom: 12px;\n}\n@media screen and (max-width: 960px) {\n  .light-form .modal .article h3 {\n    font-size: 14px;\n  }\n}\n.light-form .modal .article p {\n  color: #FCFCFC;\n  font-weight: 300;\n  line-height: 17px;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n@media screen and (max-width: 960px) {\n  .light-form .modal .article p {\n    font-size: 12px;\n  }\n}\n.light-form .modal .article .apresentacao {\n  margin-top: 16px;\n  border: 1px solid #88D4A5;\n  border-radius: 4px;\n}\n.light-form .modal .article .apresentacao p {\n  margin-bottom: 0;\n  font-size: 14px;\n}\n.light-form .modal .article .apresentacao .content {\n  padding: 8px 12px;\n  height: 100%;\n}\n.light-form .modal .article .apresentacao .content span {\n  font-weight: 700;\n  color: #FCFCFC;\n  font-size: 16px;\n}\n.light-form .modal .article .btn-checkin {\n  background-color: #88D4A5;\n  padding: 12px 16px;\n  width: 100%;\n  text-align: center;\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.light-form .modal .article .btn-checkin p {\n  margin: 0;\n  font-weight: 400;\n  color: #194248;\n}\n\ninput {\n  accent-color: #71C233;\n}\n\nlabel p {\n  color: #dcdcdc;\n}\n\nli {\n  cursor: pointer;\n}\n\ninput, textarea {\n  padding: 10px 0px;\n  background-color: transparent;\n  border: 0;\n  border-bottom: 1px solid #969597;\n  width: 100%;\n  transition: 0.3s ease;\n  color: #dcdcdc;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  line-height: 150%;\n}\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  color: rgba(220, 220, 220, 0.5);\n  font-weight: 100;\n}\ninput::placeholder, textarea::placeholder {\n  color: rgba(220, 220, 220, 0.5);\n  font-weight: 100;\n}\n\n.light-form input, textarea {\n  border-bottom: 1px solid #dcdcdc;\n  color: #767576;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  line-height: 150%;\n}\n.light-form input::-moz-placeholder, textarea::-moz-placeholder {\n  color: rgba(118, 117, 118, 0.8);\n}\n.light-form input::placeholder, textarea::placeholder {\n  color: rgba(118, 117, 118, 0.8);\n}\n\n.light-form .modal input, textarea {\n  color: #f1f1f1;\n}\n.light-form .modal input::-moz-placeholder, textarea::-moz-placeholder {\n  color: rgba(220, 220, 220, 0.8);\n}\n.light-form .modal input::placeholder, textarea::placeholder {\n  color: rgba(220, 220, 220, 0.8);\n}\n\n.light-form .modal span {\n  color: rgba(255, 255, 255, 0.6);\n}\n\nselect {\n  padding: 10px 0px;\n  background-color: rgb(36, 42, 51);\n  -webkit-background-color: rgb(36, 42, 51);\n  border: 0;\n  border-radius: 3px;\n  border-bottom: 1px solid #969597;\n  width: 100%;\n  transition: 0.3s ease;\n  color: #dcdcdc;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 14px;\n  line-height: 150%;\n}\nselect::-moz-placeholder {\n  color: rgba(220, 220, 220, 0.5);\n  font-weight: 100;\n}\nselect::placeholder {\n  color: rgba(220, 220, 220, 0.5);\n  font-weight: 100;\n}\n\n.light-form select {\n  background-color: rgba(220, 220, 220, 0.1);\n  -webkit-background-color: rgb(36, 42, 51);\n}\n\ninput::-moz-placeholder {\n  text-indent: 0;\n}\n\ninput::placeholder {\n  text-indent: 0;\n}\n\ninput:focus, select:focus, textarea:focus {\n  outline: none;\n  border-bottom: 1px solid #8CDB4F;\n}\ninput:focus::-moz-placeholder, select:focus::-moz-placeholder, textarea:focus::-moz-placeholder {\n  font-weight: 500;\n}\ninput:focus::placeholder, select:focus::placeholder, textarea:focus::placeholder {\n  font-weight: 500;\n}\n\ntextarea {\n  background-color: rgba(220, 220, 220, 0.1);\n  border-radius: 3px;\n  resize: none;\n  height: 300px;\n  padding: 10px 8px;\n}\n\n.error-input {\n  border-bottom: 1px solid #F03D3D;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.input-container input {\n  padding: 10px 32px;\n}\n.input-container .input-icon {\n  position: absolute;\n  width: 22px;\n}\n.input-container .input-icon svg path {\n  transition: stroke 0.3s ease; /* Adicione a transição desejada */\n}\n.input-container:focus-within .input-icon svg path {\n  stroke: #8CDB4F;\n}\n\n.checkbox input {\n  width: 15px;\n  margin-right: 4px;\n  padding: 0;\n}\n.checkbox label {\n  display: flex;\n}\n\n.input-people {\n  align-items: end;\n  justify-content: space-around;\n}\n.input-people .btn-add {\n  display: inline-block;\n  height: 40px;\n  width: 40px;\n  padding: 0;\n  margin-left: 8px;\n  text-decoration: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.slider {\n  display: flex;\n  margin-top: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.slider span {\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30px;\n  width: 30px;\n  border: 1px solid #969597;\n  background-color: rgb(36, 42, 51);\n  border-radius: 3px;\n  color: #dcdcdc;\n}\n\n.light-form .slider span {\n  background-color: transparent;\n  border: 1px solid #dcdcdc;\n}\n\n/* Estilizando o track do slider */\ninput[type=range] {\n  width: 100%;\n  height: 10px;\n  border: none;\n  border-radius: none;\n  background-color: transparent;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none; /* Removendo estilos padrão */\n}\n\n/* Estilizando a linha do track */\ninput[type=range]::-webkit-slider-runnable-track {\n  height: 10px;\n  border-radius: 5px;\n  background-color: rgb(36, 42, 51);\n}\n\n.light-form input[type=range]::-webkit-slider-runnable-track {\n  background-color: rgba(220, 220, 220, 0.2);\n}\n\n/* Estilizando o thumb (alça) do slider */\ninput[type=range]::-webkit-slider-thumb {\n  width: 20px;\n  height: 20px;\n  background-color: #71C233;\n  border-radius: 50%;\n  cursor: pointer;\n  -webkit-appearance: none;\n          appearance: none; /* Removendo estilos padrão */\n  margin-top: -5px; /* Ajustando a posição vertical da alça */\n}\n\n.light-form input[type=range]::-webkit-slider-thumb {\n  background-color: #8CDB4F;\n}\n\n.dashboard-filters {\n  display: block;\n  padding-bottom: 12px;\n}\n@media screen and (max-width: 540px) {\n  .dashboard-filters {\n    display: block;\n  }\n}\n\n.label-options {\n  display: flex;\n  flex-wrap: wrap;\n}\n.label-options label {\n  width: auto;\n  border: 1px solid rgba(150, 149, 151, 0.8);\n  border-radius: 3px;\n  margin-right: 12px;\n  padding: 24px 12px;\n}\n.label-options label:hover {\n  border: 1px solid #71C233;\n  background-color: rgba(220, 220, 220, 0.1);\n  cursor: pointer;\n}\n@media screen and (max-width: 540px) {\n  .label-options {\n    display: block;\n    width: 100%;\n  }\n  .label-options label {\n    margin-right: 0;\n  }\n}\n\n.filter-section {\n  margin-bottom: 8px;\n}\n\n.filter-section label {\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  margin-bottom: 8px;\n  margin-top: 8px;\n  height: 20px;\n}\n.filter-section label input {\n  width: 20px;\n}\n.filter-section label p {\n  padding-left: 4px;\n  color: #A6A6A7;\n  line-height: 14px;\n}\n\n#dashboard select {\n  margin-top: 8px;\n  background-color: transparent;\n  color: #194248;\n  border: 1px solid #71C233;\n  padding-left: 12px;\n}\n\n.body-admin {\n  height: 100vh;\n  overflow-x: hidden;\n  display: flex;\n}\n\n.menu-admin {\n  width: 150px;\n  margin-top: 90px;\n  height: calc(100vh - 83px);\n  position: fixed;\n}\n.menu-admin li {\n  background: none;\n  border-radius: 0px;\n  position: relative;\n  margin-bottom: 0;\n}\n.menu-admin li::before {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: rgba(220, 220, 220, 0.3);\n}\n.menu-admin li a {\n  padding-left: 32px;\n  color: rgba(220, 220, 220, 0.4);\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.menu-admin li a:hover {\n  background-color: rgba(220, 220, 220, 0.4);\n  color: #dcdcdc;\n}\n.menu-admin .selected::before {\n  background-color: #71C233;\n}\n.menu-admin .selected a {\n  color: rgba(220, 220, 220, 0.8);\n}\n@media screen and (max-width: 960px) {\n  .menu-admin {\n    display: none;\n  }\n}\n\n.light .menu-admin li::before {\n  background-color: #dcdcdc;\n}\n.light .menu-admin a {\n  color: #767576;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.light .menu-admin a:hover {\n  background-color: rgba(150, 149, 151, 0.4);\n  color: #194248;\n}\n.light .menu-admin .selected::before {\n  background-color: #71C233;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@media screen and (max-width: 960px) {\n  .actions {\n    display: block;\n    width: 100%;\n  }\n  .actions .profile-actions {\n    margin-top: 12px;\n    display: block;\n    justify-content: center;\n    align-items: center;\n  }\n}\n@media screen and (max-width: 540px) {\n  .actions .btn {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  .actions .btn p {\n    text-align: center;\n  }\n}\n\n.container-admin {\n  width: 100%;\n  padding-right: 16px;\n  padding-left: 16px;\n  padding-bottom: 16px;\n  margin-top: 90px;\n}\n.container-admin h3 {\n  color: rgba(220, 220, 220, 0.8);\n  font-weight: 300;\n}\n.container-admin h4 {\n  color: rgba(220, 220, 220, 0.8);\n  font-weight: 300;\n}\n.container-admin .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n@media screen and (max-width: 960px) {\n  .container-admin {\n    margin-top: 70px;\n  }\n  .container-admin .header {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: flex-start;\n  }\n  .container-admin .header h4 {\n    margin-top: 12px;\n  }\n}\n\n.light .container-admin h4 {\n  color: #194248;\n}\n\n.container-admin-menu {\n  margin-left: 158px;\n}\n@media screen and (max-width: 960px) {\n  .container-admin-menu {\n    margin-left: 0;\n  }\n}\n\n@media screen and (max-width: 960px) {\n  .container-profile {\n    margin-top: 85px;\n  }\n}\n\n.boxes {\n  padding-bottom: 16px;\n  margin-top: 16px;\n}\n\n.box {\n  width: 100%;\n  margin-bottom: 12px;\n  padding: 12px 16px;\n  border: 1px solid rgba(150, 149, 151, 0.8);\n  border-radius: 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n.box:hover {\n  border: 1px solid #71C233;\n  background-color: rgba(220, 220, 220, 0.1);\n  cursor: pointer;\n}\n.box p {\n  color: rgba(220, 220, 220, 0.8);\n}\n.box .btn {\n  padding: 8px 16px;\n}\n@media screen and (max-width: 540px) {\n  .box span {\n    display: none;\n  }\n  .box .box-content {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.light .box {\n  border: 1px solid #dcdcdc;\n}\n.light .box:hover {\n  border: 1px solid #88D4A5;\n  background-color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n}\n.light .box p {\n  color: #1F2619;\n}\n@media screen and (max-width: 540px) {\n  .light .box span {\n    display: none;\n  }\n  .light .box .box-content {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n#headerAdmin .logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n#headerAdmin .logo a {\n  padding-bottom: -5px;\n}\n#headerAdmin .logo svg {\n  width: 39px;\n  height: 50px;\n}\n@media screen and (max-width: 960px) {\n  #headerAdmin .logo-img {\n    display: none;\n  }\n  #headerAdmin .logo-img-block {\n    display: flex;\n  }\n}\n#headerAdmin .title {\n  overflow: hidden;\n  padding-left: 8px;\n  padding-top: 32px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n@media screen and (max-width: 960px) {\n  #headerAdmin .title {\n    padding-top: 0;\n    margin-left: 8px;\n    padding-left: 0;\n  }\n}\n#headerAdmin .title p {\n  color: rgba(220, 220, 220, 0.5);\n}\n#headerAdmin .light p {\n  color: #194248;\n}\n\n@media screen and (max-width: 960px) {\n  .header-profile p {\n    padding-top: 20px;\n  }\n  .header-profile svg {\n    margin-top: 20px;\n    margin-bottom: 30px;\n  }\n}\n\n.nav-admin {\n  margin-top: 12px;\n}\n.nav-admin ul {\n  display: flex;\n  position: relative;\n}\n.nav-admin ul::before {\n  content: \"\";\n  position: absolute;\n  bottom: -0.5px;\n  transform: translateY(-50%);\n  width: 100%;\n  height: 1px;\n  background-color: #909DAE;\n}\n.nav-admin li {\n  background: none;\n  border-radius: 0px;\n  position: relative;\n  margin-bottom: 0;\n}\n.nav-admin li::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  transition: all ease 0.4s;\n}\n.nav-admin li:hover::before {\n  height: 2px;\n  background-color: #71C233;\n}\n.nav-admin li a {\n  color: rgba(220, 220, 220, 0.4);\n}\n.nav-admin .selected {\n  color: rgba(220, 220, 220, 0.8);\n}\n.nav-admin .selected::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #71C233;\n}\n\n.success-message {\n  color: white;\n  padding: 8px 12px;\n  border: 1px solid #71C233;\n  background-color: gainsboro;\n}\n\n.incluir-avaliador {\n  display: flex;\n  align-items: end;\n}\n@media screen and (max-width: 540px) {\n  .incluir-avaliador {\n    display: block;\n  }\n  .incluir-avaliador .btn {\n    margin-left: 0;\n    margin-top: 8px;\n  }\n}\n\n.dashboard-summary {\n  display: flex;\n}\n\n.light h3 {\n  color: #194248;\n  font-weight: 400;\n}\n\n@media screen and (max-width: 540px) {\n  .light .avaliador .box-content {\n    overflow: visible;\n    white-space: normal;\n    display: block;\n  }\n}\n\n.table {\n  width: 100%;\n  height: 300px;\n  overflow-x: scroll;\n  overflow-y: scroll;\n}\n\ntable {\n  border-spacing: 0;\n  color: #f1f1f1;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 16px;\n  line-height: 130%;\n}\n@media screen and (max-width: 960px) {\n  table {\n    font-family: \"Source Sans Pro\", sans-serif;\n    font-size: 14px;\n    line-height: 150%;\n  }\n}\ntable thead {\n  background-color: rgba(255, 255, 255, 0.2);\n}\ntable th {\n  padding: 2px 16px;\n}\n\n.message {\n  width: 100%;\n}\n\n.error-message {\n  padding: 8px 18px;\n  background: rgba(255, 0, 0, 0.56);\n  border: 1px solid #F03D3D;\n  border-radius: 2px;\n}\n.error-message p {\n  color: #E3EBDD;\n  font-weight: 300;\n}\n\n.light .error-message {\n  background: rgba(255, 0, 0, 0.3);\n}\n.light .error-message p {\n  color: #8a0101;\n}\n\n.success-message {\n  padding: 8px 12px;\n  border: 1px solid #71C233;\n  background-color: rgba(220, 220, 220, 0.1);\n}\n.success-message p {\n  color: rgb(192, 192, 192);\n}\n\n.general {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.general .col {\n  display: block;\n  flex: 1;\n}\n.general .col:not(:last-child) {\n  margin-right: 16px; /* Adjust as needed */\n}\n.general .col .status {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n.general .col .status h4 {\n  font-size: 14px;\n  margin-right: 16px;\n}\n\n.areas .status {\n  display: flex;\n  flex-wrap: wrap;\n}\n.areas .status .box {\n  margin-right: 16px;\n  flex: 1;\n  width: 100%;\n}\n.areas .status .box h4 {\n  color: red;\n  display: block;\n  width: auto;\n}\n\n.areas .box {\n  border: 1px solid #ebaebe;\n  flex: 1;\n}\n.areas .box h4 {\n  font-size: 14px;\n}\n\n.posters, .posters-list {\n  display: flex;\n  width: 100%;\n  overflow-y: scroll;\n}\n.posters .poster, .posters .item, .posters-list .poster, .posters-list .item {\n  border: 1px solid #71C233;\n  border-radius: 3px;\n  padding: 4px 6px;\n  margin: 4px;\n}\n\n.legenda {\n  height: auto;\n}\n\n.reservado {\n  background-color: none;\n}\n\n.conflito {\n  background-color: #ebaebe;\n}\n\n.aguardando {\n  background-color: #FED150;\n}\n\n.emAvaliacao {\n  background-color: #88D4A5;\n}\n\n.posters {\n  flex-wrap: wrap;\n}\n\n.posters-list {\n  width: auto;\n  height: auto;\n}\n\n.vazio {\n  margin-top: 12px;\n}\n.vazio select {\n  width: 160px;\n}\n\n#dashboard input {\n  color: #194248;\n}\n#dashboard input::-moz-placeholder {\n  color: #969597;\n}\n#dashboard input::placeholder {\n  color: #969597;\n}\n\n.container-dashboard {\n  max-width: 850px;\n}\n\n.certificado-body {\n  height: 100vh;\n  background-color: #EDF2F2;\n  justify-content: left;\n  align-items: start;\n  border: 1px solid #818181;\n}\n.certificado-body h4 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  color: #194248;\n}\n.certificado-body p {\n  line-height: 19px;\n}\n.certificado-body .header {\n  height: 160px;\n  width: 100%;\n  background-color: #FFF;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  padding: 40px;\n}\n.certificado-body .header svg {\n  height: 114px;\n  width: auto;\n  margin-right: 18px;\n}\n.certificado-body .header .title {\n  display: flex;\n  align-items: center;\n  margin-top: 60px;\n}\n.certificado-body .header .title p {\n  margin-left: 24px;\n  border-left: 2px solid #71C233;\n  padding: 10px;\n}\n.certificado-body .section {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100vh - 200px);\n}\n.certificado-body .content {\n  padding: 40px;\n  max-width: 800px;\n}\n.certificado-body .content h4 {\n  font-size: 40px;\n  margin-bottom: 20px;\n  font-family: \"Inter\", sans-serif;\n}\n.certificado-body .content p {\n  font-weight: 300;\n}\n.certificado-body .content p, .certificado-body .content span {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n.certificado-body .content span {\n  font-weight: 500;\n}\n.certificado-body .content .autenticacao {\n  margin-top: 40px;\n  display: flex;\n}\n.certificado-body .content .autenticacao p {\n  font-size: 12px;\n  margin-top: 8px;\n  line-height: 14px;\n}\n.certificado-body .content .autenticacao span {\n  margin-left: 10px;\n  line-height: 12px;\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n.certificado-body .footer {\n  padding: 0 40px;\n}\n.certificado-body .footer svg {\n  height: 30px;\n  width: auto;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}\n.certificado-body .footer div {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: left;\n}\n\n@media print {\n  .certificado-body {\n    box-shadow: 0 0 0 1000px #EDF2F2 inset; /* cor para impressão */\n  }\n}\n.avaliador .logo h3 {\n  background-color: #88D4A5;\n  font-size: 14px;\n  width: 100%;\n  padding: 8px 16px;\n  text-align: center;\n  border-radius: 4px;\n  color: #194248;\n}\n.avaliador select {\n  color: #194248;\n}\n\n.resumosHtml-body {\n  background-color: #FFF;\n  justify-content: left;\n  align-items: start;\n  border: 1px solid #818181;\n}\n.resumosHtml-body .page-break {\n  page-break-before: always; /* ou page-break-after: always; */\n}\n.resumosHtml-body h4 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #194248;\n}\n.resumosHtml-body p, .resumosHtml-body span {\n  line-height: 19px;\n  font-size: 12px;\n}\n.resumosHtml-body .header {\n  height: 160px;\n  width: 100%;\n  background-color: #FFF;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  padding: 40px;\n}\n.resumosHtml-body .header svg {\n  height: 114px;\n  width: auto;\n  margin-right: 18px;\n}\n.resumosHtml-body .header .title {\n  display: flex;\n  align-items: center;\n  margin-top: 60px;\n}\n.resumosHtml-body .header .title p {\n  margin-left: 24px;\n  border-left: 2px solid #71C233;\n  padding: 10px;\n}\n.resumosHtml-body .resumos {\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n.resumosHtml-body .resumos h4 {\n  margin-bottom: 12px;\n}\n.resumosHtml-body .section {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100vh - 200px);\n}\n.resumosHtml-body .content {\n  padding: 40px;\n  max-width: 800px;\n}\n.resumosHtml-body .content h4 {\n  font-size: 40px;\n  margin-bottom: 20px;\n  font-family: \"Inter\", sans-serif;\n}\n.resumosHtml-body .content p {\n  font-weight: 300;\n}\n.resumosHtml-body .content p, .resumosHtml-body .content span {\n  font-size: 10px;\n  font-family: \"Inter\", sans-serif;\n}\n.resumosHtml-body .content span {\n  font-weight: 500;\n}\n.resumosHtml-body .content .autenticacao {\n  margin-top: 40px;\n  display: flex;\n}\n.resumosHtml-body .content .autenticacao p {\n  font-size: 10px;\n  margin-top: 8px;\n  line-height: 14px;\n}\n.resumosHtml-body .content .autenticacao span {\n  margin-left: 10px;\n  line-height: 12px;\n  font-size: 10px;\n  font-family: \"Inter\", sans-serif;\n}\n.resumosHtml-body .footer {\n  padding: 0 40px;\n}\n.resumosHtml-body .footer svg {\n  height: 30px;\n  width: auto;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}\n.resumosHtml-body .footer div {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: left;\n}\n\n@media print {\n  .certificado-body {\n    box-shadow: 0 0 0 1000px #EDF2F2 inset; /* cor para impressão */\n  }\n  .no-print {\n    display: none !important;\n  }\n}/*# sourceMappingURL=style.css.map */","*, *::before, *::after{\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n*{\n    scrollbar-width: none; /* ParaFirefox */\n    -ms-overflow-style: none; /* Para Internet Explorer e Edge */\n}\n*::-webkit-scrollbar {\n    width: 0px; /* Para Chrome, Safari, e Opera */\n    display: none \n}\n\n@import \"partials/spacing\";\n@import \"partials/colors\";\n@import \"partials/layout\";\n@import \"partials/typography\";\n@import \"partials/buttons\";\n\nhtml{\n    scroll-behavior: smooth;\n}\n \nbody{ \n    width: 100%;\n    height: 100vh;\n    position: relative;\n    scroll-behavior: smooth;\n    overflow-x: hidden;\n    background: linear-gradient(168.19deg, #020b18 7.54%, #0a172a 61.3%, #08172b 96.07%);\n    background-attachment: fixed;\n}\n\n\n\n \nsvg,img{\n    display: block;\n    width: 100%;\n}\n \n.border{\n    border: 1px solid red;\n}\n\n@import \"partials/menu\";\n@import \"partials/swiper\";\n@import \"partials/icons\";\n@import \"partials/footer\";\n@import \"partials/animations\";\n@import \"partials/signin-singup\";\n@import \"partials/profile.scss\";\n@import \"partials/list.scss\";\n@import \"partials/modal.scss\";\n@import \"partials/form.scss\";\n@import \"partials/admin\";\n@import \"partials/table\";\n@import \"partials/notify\";\n@import \"partials/dashboard\";\n@import \"partials/certificado\";\n@import \"partials/avaliador\";\n@import \"partials/resumosHtml\";\n\n\n\n\n\n\n\n","$gap-1:8px;\n$gap-2:12px;\n$gap-3:16px;\n$gap-4:24px;\n$gap-5:32px;\n$gap-6:40px;\n$gap-7:48px;\n$gap-8:56px;\n$gap-9:72px;\n$gap-10:96px;\n$gap-11:128px;\n\n.m-0{\n    margin: 0;\n    padding: 0;\n}\n.m-1{\n    margin:$gap-1;\n}\n.m-2{\n    margin:$gap-2;\n}\n.m-3{\n    margin:$gap-3;\n}\n.m-4{\n    margin:$gap-4;\n}\n.m-5{\n    margin:$gap-5;\n}\n.m-6{\n    margin:$gap-6;\n}\n\n.mt-0{\n    margin-top:0;\n}\n.mt-1{\n    margin-top:$gap-1;\n}\n.mt-2{\n    margin-top:$gap-2;\n}\n.mt-3{\n    margin-top:$gap-3;\n}\n.mt-4{\n    margin-top:$gap-4;\n}\n.mt-5{\n    margin-top:$gap-5;\n}\n.mt-6{\n    margin-top:$gap-6;\n}\n\n\n.ml-1{\n    margin-left:$gap-1;\n}\n.ml-2{\n    margin-left:$gap-2;\n}\n.ml-3{\n    margin-left:$gap-3;\n}\n.ml-4{\n    margin-left:$gap-4;\n}\n.ml-5{\n    margin-left:$gap-5;\n}\n.ml-6{\n    margin-left:$gap-6;\n}\n\n\n.mr-1{\n    margin-right:$gap-1;\n}\n.mr-2{\n    margin-right:$gap-2;\n}\n.mr-3{\n    margin-right:$gap-3;\n}\n.mr-4{\n    margin-right:$gap-4;\n}\n.mr-5{\n    margin-right:$gap-5;\n}\n.mr-6{\n    margin-right:$gap-6;\n}\n\n.mb-0{\n    margin-bottom:0;\n}\n.mb-1{\n    margin-bottom:$gap-1;\n}\n.mb-2{\n    margin-bottom:$gap-2;\n}\n.mb-3{\n    margin-bottom:$gap-3;\n}\n.mb-4{\n    margin-bottom:$gap-4;\n}\n.mb-5{\n    margin-bottom:$gap-5;\n}\n.mb-6{\n    margin-bottom:$gap-6;\n}\n\n\n.mx-1{\n    margin-left:$gap-1;\n    margin-right:$gap-1;\n}\n.mx-2{\n    margin-left:$gap-2;\n    margin-right:$gap-2;\n}\n.mx-3{\n    margin-left:$gap-3;\n    margin-right:$gap-3;\n}\n.mx-4{\n    margin-left:$gap-4;\n    margin-right:$gap-4;\n}\n.mx-5{\n    margin-left:$gap-5;\n    margin-right:$gap-5;\n}\n.mx-6{\n    margin-left:$gap-6;\n    margin-right:$gap-6;\n}\n\n.my-1{\n    margin-top:$gap-1;\n    margin-bottom:$gap-1;\n}\n.my-2{\n    margin-top:$gap-2;\n    margin-bottom:$gap-2;\n}\n.my-3{\n    margin-top:$gap-3;\n    margin-bottom:$gap-3;\n}\n.my-4{\n    margin-top:$gap-4;\n    margin-bottom:$gap-4;\n}\n.my-5{\n    margin-top:$gap-5;\n    margin-bottom:$gap-5;\n}\n.my-6{\n    margin-top:$gap-6;\n    margin-bottom:$gap-6;\n}\n\n\n.p-1{\n    padding:$gap-1;\n}\n.p-2{\n    padding:$gap-2;\n}\n.p-3{\n    padding:$gap-3;\n}\n.p-4{\n    padding:$gap-4;\n}\n.p-5{\n    padding:$gap-5;\n}\n.p-6{\n    padding:$gap-6;\n}\n\n.pt-1{\n    padding-top:$gap-1;\n}\n.pt-2{\n    padding-top:$gap-2;\n}\n.pt-3{\n    padding-top:$gap-3;\n}\n.pt-4{\n    padding-top:$gap-4;\n}\n.pt-5{\n    padding-top:$gap-5;\n}\n.pt-6{\n    padding-top:$gap-6;\n}\n.pt-7{\n    padding-top:$gap-7;\n}\n.pt-8{\n    padding-top:$gap-8;\n}\n.pt-9{\n    padding-top:$gap-9;\n}\n.pt-10{\n    padding-top:$gap-10;\n}\n.pt-11{\n    padding-top:$gap-11;\n}\n\n.pl-0{\n    padding-left:0;\n}\n.pl-1{\n    padding-left:$gap-1;\n}\n.pl-2{\n    padding-left:$gap-2;\n}\n.pl-3{\n    padding-left:$gap-3;\n}\n.pl-4{\n    padding-left:$gap-4;\n}\n.pl-5{\n    padding-left:$gap-5;\n}\n.pl-6{\n    padding-left:$gap-5;\n}\n\n.pr-1{\n    padding-right:$gap-1;\n}\n.pr-2{\n    padding-right:$gap-2;\n}\n.pr-3{\n    padding-right:$gap-3;\n}\n.pr-4{\n    padding-right:$gap-4;\n}\n.pr-5{\n    padding-right:$gap-5;\n}\n.pr-6{\n    padding-right:$gap-6;\n}\n\n.pb-1{\n    padding-bottom:$gap-1;\n}\n.pb-2{\n    padding-bottom:$gap-2;\n}\n.pb-3{\n    padding-bottom:$gap-3;\n}\n.pb-4{\n    padding-bottom:$gap-4;\n}\n.pb-5{\n    padding-bottom:$gap-5;\n}\n.pb-6{\n    padding-bottom:$gap-6;\n}\n.px-0{\n    padding-left:0;\n    padding-right:0;\n}\n.px-1{\n    padding-left:$gap-1;\n    padding-right:$gap-1;\n}\n.px-2{\n    padding-left:$gap-2;\n    padding-right:$gap-2;\n}\n.px-3{\n    padding-left:$gap-3;\n    padding-right:$gap-3;\n}\n.px-4{\n    padding-left:$gap-4;\n    padding-right:$gap-4;\n}\n.px-5{\n    padding-left:$gap-5;\n    padding-right:$gap-5;\n}\n\n.py-1{\n    padding-top:$gap-1;\n    padding-bottom:$gap-1;\n}\n.py-2{\n    padding-top:$gap-2;\n    padding-bottom:$gap-2;\n}\n.py-3{\n    padding-top:$gap-3;\n    padding-bottom:$gap-3;\n}\n.py-4{\n    padding-top:$gap-4;\n    padding-bottom:$gap-4;\n}\n.py-5{\n    padding-top:$gap-5;\n    padding-bottom:$gap-5;\n}","//Gradients\n\n\n//Colors of project \n$color-green-light-3:#C3FF94; \n$color-green-light-2:#AAF571; \n$color-green-light-1:#8CDB4F; \n$color-green:#71C233; \n$color-green-dark-1:#58A81B; \n$color-green-dark-2:#438F09; \n$color-green-dark-3:#337500; \n$light-green-2-medium: #88D4A5;\n$light-black-green:#194248;\n.color-green-light-3{color: $color-green-light-3}\n.color-green-light-2{color: $color-green-light-2}\n.color-green-light-1{color: $color-green-light-1}\n.color-green{color: $color-green}\n.color-green-dark-1{color: $color-green-dark-1}\n.color-green-dark-2{color: $color-green-dark-2}\n.color-green-dark-3{color: $color-green-dark-3}\n.light-green-2-medium{color:$light-green-2-medium}\n.light-black-green{color:$light-black-green}\n\n$color-white-light-3:#FEFFFC; \n$color-white-light-2:#FBFCFA; \n$color-white-light-1:#232e3f; \n$color-white:#dcdcdc; \n$color-white-dark-1:#D8DBE3; \n$color-white-dark-2:#E3EBDD; \n$color-white-dark-3:#DBE5D3; \n.color-white-light-3{color: $color-white-light-3}\n.color-white-light-2{color: $color-white-light-2}\n.color-white-light-1{color: $color-white-light-1}\n.color-white{color: $color-white}\n.color-white-dark-1{color: $color-white-dark-1}\n.color-white-dark-2{color: $color-white-dark-2}\n.color-white-dark-3{color: $color-white-dark-3}\n\n$color-black-light-3:#353D2E; \n$color-black-light-2:#2D3627; \n$color-black-light-1:#262E20; \n$color-black:#1F2619; \n$color-black-dark-1:#181F13; \n$color-black-dark-2:#12170E; \n$color-black-dark-3:#0C0F09; \n.color-black-light-3{color: $color-black-light-3}\n.color-black-light-2{color: $color-black-light-2}\n.color-black-light-1{color: $color-black-light-1}\n.color-black{color: $color-black}\n.color-black-dark-1{color: $color-black-dark-1}\n.color-black-dark-2{color: $color-black-dark-2}\n.color-black-dark-3{color: $color-black-dark-3}\n\n$gray-1:#454446;\n$gray-2:#555456;\n$gray-3:#666566; \n$gray-4:#767576;\n$gray-5:#868587;\n$gray-6:#969597;\n$gray-7:#A6A6A7;\n$gray-8:#f1f1f1;\n.color-gray-1{color:$gray-1}\n.color-gray-2{color:$gray-2}\n.color-gray-3{color:$gray-3}\n.color-gray-4{color:$gray-4}\n.color-gray-5{color:$gray-5}\n.color-gray-6{color:$gray-6}\n.color-gray-7{color:$gray-7}\n\n$auxiliary-red: #E7587D;\n$auxiliary-red-light: #F1819E;\n$auxiliary-red-extralight: #ebaebe;\n$auxiliary-red-dark: #C64869;\n.auxiliary-red{color: $auxiliary-red}\n.auxiliary-red-light{color: $auxiliary-red-light}\n.auxiliary-red-dark{color: $auxiliary-red-dark}\n\n$auxiliary-blue: #5B89F4;\n$auxiliary-blue-light: #83A7FB;\n$auxiliary-blue-dark: #4A73D2;\n.auxiliary-blue{color: $auxiliary-blue}\n.auxiliary-blue-light{color: $auxiliary-blue-light}\n.auxiliary-blue-dark{color: $auxiliary-blue-dark}\n\n$auxiliary-yellow: #F6BD18;\n$auxiliary-yellow-light: #FED150;\n$auxiliary-yellow-dark: #D5A210;\n.auxiliary-yellow{color: $auxiliary-yellow}\n.auxiliary-yellow-light{color: $auxiliary-yellow-light}\n.auxiliary-yellow-dark{color: $auxiliary-yellow-dark}\n\n\n","//Layout of project\n\n//Container devices\n$container-xl:1440px;\n$container-l:1140px;\n$container-m:960px;\n$container-s:540px;\n\n//Mixins of media query\n@mixin responsive($device) {\n    @if $device == xl{\n        //For resolutions upper than 1440px\n        @media screen and (min-width:$container-xl) {\n            @content;\n        }\n    }\n    @else if $device == l{\n        //For resolutions between 1140px and 1440px\n        @media screen and (max-width:$container-xl) and (min-width:$container-l) {\n            @content;\n        }\n    }\n    @else if $device == m{\n        //For resolutions between 960px and 1140px\n        @media screen and (max-width:$container-l) and (min-width:$container-m) {\n            @content;\n        }\n    }\n    @else if $device == s{\n        //For resolutions less than 960px \n        @media screen and (max-width:$container-m){\n            @content;\n        }\n    }\n    @else if $device == xs{\n        //For resolutions less than 540px \n        @media screen and (max-width:$container-s){\n            @content;\n        }\n    }\n}\n\n.container{\n    max-width: 900px;\n    margin: auto;\n    padding: $gap-10 $gap-5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    @include responsive(s){\n        padding: $gap-9 $gap-4;\n        flex-direction: column;\n    }\n}\n\n\n\n\nli{\n    list-style: none;\n}\n\n.flex-start{\n    display: flex;\n    justify-content: flex-start;\n    align-items:start;\n}\n.flex-end{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.flex-center{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.flex-center-space-between{\n    display: flex;\n    justify-content:space-between;\n    align-items: center;\n}\n.flex-column{\n    flex-direction: column;\n}\n.relative{\n    position: relative;\n}\n.flex-wrap{\n    flex-wrap: wrap;\n}\n.flex-item-1{\n    flex: 1 1 360px;\n}\n.flex-item-2{\n    flex: 2 1 360px;\n}\n.flex-item-3{\n    flex: 3 1 360px;\n}\n.flex-item-4{\n    flex: 4 1 360px;\n}\n.flex-item-5{\n    flex: 5 1 360px;\n}\n.flex-item-auto{\n    flex: 2 1 auto;\n}\n.w-auto{\n    width: auto;\n}\n.w-100{\n    width: 100%;\n}\n.w-75{\n    width: 75%;\n}\n.w-50{\n    width: 50%;\n}\n.w-25{\n    width: 25%;\n}\n.hidden{\n    overflow: hidden;\n}\n.height-100vh{\n    height: 100vh;\n}\n.display-none{\n    display: none;\n}\n.display-block{\n    display: block;\n}\n.display-inline-block{\n    display: inline-block;\n}\n.display-flex{\n    display: flex;\n}\n.flex-1{\n    flex: 1;\n}\n.flex-end{\n    align-items:end;\n}\n.display-inline-block{\n    display: inline-block;\n}\n.visible {\n    visibility: hidden;\n}\n.spacing-top-article{\n    height: 150px;\n    @include responsive(s){\n        height: 115px;\n    }\n}\n\n.nowrap{\n    overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 40ch;\n}\n\n.col-2{\n    display: flex;\n}\n.cursor-pointer{\n    cursor: pointer;\n}\n","//Typography of project\n@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&family=Source+Sans+Pro:wght@300;400&display=swap');\n@mixin typeface-1 ($size,$device:desktop) {\n    \n    font-family: 'Rubik', sans-serif;\n    //H1\n    @if $size == h1 and $device == desktop{\n        font-size: 64px;\n        line-height: 100%;\n    }@else if $size == h1 and $device == mobile{\n        font-size: 36px;\n        line-height: 120%;\n    }\n    //H2\n    @else if $size == h2 and $device == desktop{\n        font-size: 52px;\n        line-height: 110%;\n    }@else if $size == h2 and $device == mobile{\n        font-size: 36px;\n        line-height: 120%;\n    }\n    //H3\n    @else if $size == h3 and $device == desktop{\n        font-size: 36px;\n        line-height: 115%;\n    }@else if $size == h3 and $device == mobile{\n        font-size: 24px;\n        line-height: 120%;\n    }\n    //H4\n    @else if $size == h4 and $device == desktop{\n        font-size: 24px;\n        line-height: 130%;\n    }@else if $size == h4 and $device == mobile{\n        font-size: 18px;\n        line-height: 130%;\n    }\n    //H5\n    @else if $size == h5 and $device == desktop{\n        font-size: 18px;\n        line-height: 140%;\n    }@else if $size == h5 and $device == mobile{\n        font-size: 16px;\n        line-height: 150%;\n    }\n}\n\n@mixin typeface-2 ($size:p2,$device:desktop) {\n    \n    font-family: 'Source Sans Pro', sans-serif;\n    //P1\n    @if $size == p1 and $device == desktop{\n        font-size: 24px;\n        line-height: 130%;\n    }@else if $size == p1 and $device == mobile{\n        font-size: 18px;\n        line-height: 130%;\n    }\n    //P2\n    @else if $size == p2 and $device == desktop{\n        font-size: 16px;\n        line-height: 130%;\n    }@else if $size == p2 and $device == mobile{\n        font-size: 14px;\n        line-height: 150%;\n    }\n    //P3\n    @else if $size == p3 and $device == desktop{\n        font-size: 14px;\n        line-height: 150%;\n    }@else if $size == p3 and $device == mobile{\n        font-size: 14px;\n        line-height: 150%;\n    }\n}\n\nh1{\n    color: $color-black-dark-2;\n    @include typeface-1(h1,desktop);\n    @include responsive(s){\n        @include typeface-1(h1,mobile);\n    }\n}\nh2{\n    color: $color-black-dark-2;\n    @include typeface-1(h2,desktop);\n    @include responsive(s){\n        @include typeface-1(h2,mobile);\n    }\n}\nh3{\n    color: $color-black-dark-2;\n    @include typeface-1(h3,desktop);\n    @include responsive(s){\n        @include typeface-1(h3,mobile);\n    }\n}\nh4{\n    color: $color-black-dark-2;\n    @include typeface-1(h4,desktop);\n    @include responsive(s){\n        @include typeface-1(h4,mobile);\n    }\n}\n\nh5{\n    text-transform: uppercase;\n    background: linear-gradient(180deg, $color-green-dark-2  0%, $color-green-dark-3 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-weight: bold;\n    @include typeface-1(h5,desktop);\n    @include responsive(s){\n        @include typeface-1(h5,mobile);\n    }\n}\n\np{\n    color:$gray-4;\n    @include typeface-2(p2,desktop);\n    @include responsive(s){\n        @include typeface-2(p3,mobile);\n    }\n}\n.light p{\n    color:$light-black-green\n}\n\n\n.bold{\n    font-weight: bold;\n    color: $color-black-light-2;\n}\nspan{\n    color:$gray-4;\n    @include typeface-2(p3,desktop);\n    @include responsive(s){\n        @include typeface-2(p3,mobile);\n    }\n    a{\n        color:$auxiliary-red-dark;\n        @include typeface-2(p3,desktop);\n    }\n    a:hover{\n        color:$auxiliary-red-light;\n    }\n}\nstrong{\n    font-weight: bold;\n    color: red;\n}\n.small-warning{\n    font-weight:400;\n    color: $auxiliary-red-dark;\n}\n.text-align-center{\n    text-align: center;\n}\n.text-align-right{\n    text-align: right;\n}\n.text-align-left{\n    text-align: left;\n}\n\n.text-wight-light{\n    color: $gray-4;\n    font-size: 12px;\n    font-weight: 300;\n}\n.longText{\n    font-size: 16px;\n    line-height: 170%;\n    @include responsive(s){\n        font-size: 14px;\n        line-height: 160%;\n    }\n}\n.font-size-10{\n    font-size: 10px;\n}\n.font-size-12{\n    font-size: 12px;\n}\n    ",".btn{\n    display: inline-block;\n    padding: 14px 28px;\n    border-radius: 2px;\n    border: 0;\n    cursor: pointer;\n    background: $color-white;\n    transition: background-color 0.3s ease; /* Adicione a transição desejada */\n    &:hover{\n        background-color: rgba($color: #FFF, $alpha: 0.8);\n    }\n}\n\n.light .btn{\n    border-radius: $gap-1;\n    cursor: pointer;\n    background: $light-green-2-medium;\n    border: 1px solid $light-green-2-medium;\n    transition: background-color 0.3s ease; /* Adicione a transição desejada */\n    &:hover{\n        background-color: rgba($color: $light-green-2-medium, $alpha: 0.8);\n    }\n}\n.btn-danger{\n    border: 1px solid $auxiliary-red;\n    background-color: $auxiliary-red-light;\n    p{\n        color: white;\n    }\n    &:hover{\n        background-color: rgba($color: red, $alpha: 0.8);\n    }\n}\n\n\n\n\n.btn-secondary{\n    background-color: rgba($color: #FFF, $alpha: 0.2);\n    color: $color-white;\n    p{\n        color: rgba($color: #FFF, $alpha: 0.8);;\n    }\n    \n    &:hover{\n        background-color: rgba($color: #FFF, $alpha: 0.1);\n    }\n}\n\n.light .btn-secondary{\n    background-color: rgba($color: #FFF, $alpha: 0);\n    color: $color-white;\n    p{\n        color: rgba($light-black-green, $alpha: 0.8);;\n    }\n    border: 1px solid $light-green-2-medium;\n    &:hover{\n        background-color: rgba($color: #FFF, $alpha: 1);\n    }\n}\n\n\n\na,.button-link{\n    display: inline-block;\n    text-decoration: none;\n    @include typeface-2(p3, desktop);\n    color: $color-white;\n    transition: .3s ease;\n    cursor: pointer;\n    &:hover{\n        opacity: 0.9;\n    }\n}\n\n.light a,.light .button-link{\n    color: $light-black-green;\n    \n   \n}\n.button-link{\n    display: block;\n    background-color: transparent;\n    border: none;\n    height: 100%;\n    padding: 10px 24px;\n    &:hover{\n        color:rgba($color: #FFF, $alpha: 0.5)\n    }\n}\n\n.light .button-link{\n    \n    &:hover{\n        color:rgba($light-black-green, $alpha: 0.5)\n    }\n}\n\n.logo a{\n    padding: 0;\n}\n.btn-icon{\n    padding: 10px;\n}\n","header{\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 70px;\n    position: fixed;\n    z-index: 999;\n    background-color: rgba(255, 255, 255, 0); /* Defina a cor de fundo inicialmente como transparente */\n    backdrop-filter: blur(6px);\n    transition: background-color 0.3s; /* Adicione uma transição suave para a mudança de cor de fundo */\n    cursor: pointer;\n}\nnav{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items:center;\n}\n.menu{\n    list-style: none;\n    display: flex;\n    li{\n        margin-left: 24px;\n    }\n    @include responsive(s){\n        display: none;\n    }\n}\n.logo{\n    margin-left: $gap-2;\n    img{\n        height: 50px;\n    }\n}\n.bx{\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    border: 1px solid red;\n    position: relative;\n    display: none;\n    @include responsive(s){\n        display: block;\n    }\n    &::after{\n        content:'';\n        width:70%;\n        height: 2px;\n        display: block;\n\n        position: absolute;\n        top: 35%;\n        left:40%;\n\n        transform: translate(-50%,-50% );\n        border-radius: 2px;\n\n        background-color: $color-white-light-2;\n    }\n    &::before{\n        content:'';\n        width:70%;\n        height: 2px;\n        display: block;\n\n        position: absolute;\n        top: 65%;\n        left:60%;\n\n        transform: translate(-50%,-50% );\n        border-radius: 2px;\n\n        background-color: $color-white-light-2;\n    }\n}\n\n.cta-desktop{\n    display: block;\n    @include responsive(s){\n        display: none;\n    }\n}\n\n.cta-mobile{\n    display: none;\n    @include responsive(s){\n        display: block;\n    }\n}","$dropshadow:drop-shadow(0px 16px 24px rgba(169,80,196,0.25));\n.dropshadow{\n    filter: $dropshadow;\n}\n.icon-close{\n    display: block;\n    width: 20px;\n    height: 20px;\n}\n\n/* Estilos para o ícone do hambúrguer */\n.icon-menu {\n    width: 30px;\n    height: 20px;\n    margin-left: $gap-1;\n    display: none;\n    flex-direction: column;\n    justify-content: space-between;\n    cursor: pointer;\n    \n    @include responsive(s){\n        display: flex;\n    }\n    &:hover div{\n        background-color: $color-green;\n    }\n  }\n\n\n/* Estilos para as linhas do ícone */\n.icon-menu div {\n    width: 25px;\n    height: 3px;\n    border-radius: 3px;\n    background-color: $color-white;\n    transition: .3s ease;\n  }\n  .light .icon-menu div{\n    background-color:$gray-5\n  }\n.status{\n    display: flex;\n    align-items: center;\n    margin-top: calc($gap-1/2);\n    .icon-ball{\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        margin-right: calc($gap-1/2);\n    }\n    .icon-ball-red{\n        background-color: $auxiliary-red;\n    }\n    .icon-ball-orange{\n        background-color: rgb(224, 100, 54);\n    }\n    .icon-ball-white{\n        background-color: $color-white;\n    }\n    .icon-ball-yellow{\n        background-color: $auxiliary-yellow;\n    }\n    .icon-ball-green{\n        background-color: $color-green;\n    }\n\n    \n}",".container-signin-signup{\n    height: 100vh;\n    max-width: 300px;\n    padding: $gap-2;\n}\n.signin{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    .logo{\n        margin: 0;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        img{\n            height: 100%;\n        }\n    }\n    form{\n        width: 100%;\n    }\n}\n.light .container{\n    display: flex;\n    flex-direction: column;\n    a{\n        padding-top: $gap-2;\n        width: 100%;\n        text-align: right;\n    }\n}","\n.profile{\n    width: 100%;  \n    h3{\n        font-weight: 400;\n        color: $color-white;\n    } \n    .welcome p{\n        color: $color-white-dark-1;\n        opacity: 0.8;\n    } \n    .welcome{\n        max-width: 300px;\n    }\n    .listaCongressos{\n        margin-top: $gap-2;\n    }\n    .profile-header{\n        display: flex;\n\n        .profile-actions{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n        @include responsive(s){\n            display: block;\n            .profile-actions{\n                \n                margin-top: $gap-2;\n                display: block;\n                justify-content: center;\n                align-items: center;\n    \n            }\n        }\n        @include responsive(xs){\n            .btn{\n                width: 100%;\n                margin-bottom: $gap-1;\n                p{\n                    text-align: center;\n                }\n            }\n        }\n    }\n}\n\n\n","li{\n    a{\n        padding: 12px 18px;\n        width: 100%;\n        height: 100%;\n    }\n    margin-bottom: 8px;\n    border-radius: 2px;\n    background-color: rgba($color: #FFF, $alpha: 0.2);\n    color: $color-white;\n    &:hover{\n        background-color: rgba($color: #FFF, $alpha: 0.1);\n    }\n}",".container-modal{\n    width: 100%;\n    position: absolute;\n    z-index: 9999;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.49);\n    backdrop-filter: blur(17.8px);\n    display: none;\n    transition: all 0.3s ease;\n\n}\n\n.menu .header-modal{\n    display: flex;\n    justify-content: center;\n    margin-bottom: $gap-3;\n    \n}\n.container-modal.show {\n    display: flex;\n   \n\n}\n.header-modal{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.modal{\n    width: 500px;\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    .content{\n        padding: 20px;\n        height: calc(90vh);\n        overflow-y: scroll;\n        //margin-top:$gap-4;\n\n    }\n    \n    h3{\n        font-weight: 300;\n        color: $color-white;\n    }\n    .modal-actions{\n        button, a{\n            width: 100%;\n            margin-bottom: $gap-2;\n        }\n        a{\n            text-align: center;\n        }\n    }\n    \n}\n.menu{\n    li{\n        margin-left: 0;\n    }\n    .content{\n        padding-left: $gap-1;\n        padding-right: $gap-1;\n    }\n    a{\n        text-align: center;\n    }\n}\n.light-form .modal .article{\n    h3{\n        font-size: 18px;\n        text-transform: uppercase;\n        font-weight: 400;\n        @include responsive(s){\n            font-size: 14px;\n        }\n        margin-bottom: $gap-2;\n    }\n    \n    p{\n        color: #FCFCFC;\n        font-weight: 300;\n        line-height: 17px;\n        font-size: 14px;\n        margin-bottom: $gap-1;\n        @include responsive(s){\n            font-size: 12px;\n        }\n    }\n    .apresentacao{\n        margin-top: $gap-3;\n        border: 1px solid $light-green-2-medium;\n        border-radius: 4px;\n        p{\n            margin-bottom: 0;\n            font-size: 14px;\n        }\n        .content{\n            padding: $gap-1 $gap-2;\n            height: 100%;\n            span{\n                font-weight: 700;\n                color: #FCFCFC;\n                font-size: 16px;\n            }\n        }\n    }\n    .btn-checkin{\n        background-color: $light-green-2-medium;\n        padding: $gap-2 $gap-3;\n        width: 100%;\n        text-align: center;\n        border-radius: 4px;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n        p{\n            margin: 0;\n            font-weight: 400;\n            color: $light-black-green;\n        }\n        \n    }\n}","\ninput{\n    accent-color: $color-green;  \n}\nlabel p{\n    color: $color-white;\n}\n\n\nli{\n    cursor: pointer;\n}\ninput, textarea{\n    padding: 10px 0px;\n    background-color: transparent;\n    border: 0;\n    border-bottom: 1px solid $gray-6;\n    width: 100%;\n    transition: 0.3s ease;\n    color: $color-white;\n    &::placeholder {\n        color: rgba($color: $color-white, $alpha: 0.5);\n        font-weight: 100;\n      }\n    @include typeface-2(p3, desktop)\n}\n.light-form input, textarea{\n    border-bottom: 1px solid #dcdcdc;\n    color: $gray-4;\n    &::placeholder {\n        color: rgba($color: $gray-4, $alpha: 0.8);\n      }\n    @include typeface-2(p3, desktop)\n}\n.light-form .modal input, textarea{\n    color: $gray-8;\n    &::placeholder {\n        color: rgba($color: $color-white, $alpha: 0.8);\n      }\n   \n}\n.light-form .modal{\n    span{\n        color: rgba(255, 255, 255, 0.6)\n    }\n}\n\nselect{\n    padding: 10px 0px;\n    background-color: rgb(36, 42, 51);\n    -webkit-background-color: rgb(36, 42, 51);\n    border: 0; \n    border-radius: 3px;\n    border-bottom: 1px solid $gray-6;\n    width: 100%;\n    transition: 0.3s ease;\n    color: $color-white;\n    &::placeholder {\n        color: rgba($color: $color-white, $alpha: 0.5);\n        font-weight: 100;\n      }\n    @include typeface-2(p3, desktop)\n}\n.light-form select{\n    background-color: rgba($color: $color-white, $alpha: 0.1);\n    -webkit-background-color: rgb(36, 42, 51);\n}\n\ninput::placeholder {\n    text-indent: 0;\n  }\n\ninput:focus, select:focus, textarea:focus{\n    outline: none;\n    border-bottom: 1px solid $color-green-light-1;\n    &::placeholder {\n        font-weight: 500;\n      }\n}\n\ntextarea{\n    background-color: rgba($color: $color-white, $alpha: 0.1);\n    border-radius: 3px;\n    resize: none;\n    height: 300px;\n    padding: 10px 8px;\n}\n.error-input{\n    border-bottom: 1px solid #F03D3D;\n}\n\n.input-container{\n    position: relative;\n    display: flex;\n    align-items: center;\n    input{\n        padding: 10px 32px;\n    }\n    .input-icon{\n        position: absolute;\n        width: 22px;\n        \n    }\n\n    .input-icon svg path{\n        transition: stroke 0.3s ease; /* Adicione a transição desejada */\n\n    }\n\n    &:focus-within .input-icon svg path {\n        stroke: $color-green-light-1;\n      }\n\n}\n\n.checkbox{\n    input{\n        width: 15px;\n        margin-right: 4px;\n        padding: 0;\n        \n    }\n    label{\n        display: flex;\n    }\n}\n.input-people{\n    align-items:end;\n    justify-content: space-around;\n    .btn-add{\n        display: inline-block;\n        height: 40px;\n        width: 40px;\n        padding: 0;\n        margin-left: 8px;\n        text-decoration: none;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        \n        \n    };\n    \n}\n.slider{\n    display: flex;\n    margin-top: 10px;\n    justify-content: center;\n    align-items: center;\n    span{\n        margin-left: $gap-1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 30px;\n        width: 30px;\n        border: 1px solid $gray-6;\n        background-color: rgb(36, 42, 51);\n        border-radius: 3px;\n        color: $color-white;\n    }\n}\n.light-form .slider span{\n    background-color: transparent;\n    border: 1px solid #dcdcdc;\n}\n\n /* Estilizando o track do slider */\ninput[type=\"range\"] {\n    width: 100%;\n    height: 10px;\n    border: none;\n    border-radius: none;\n    background-color: transparent;\n    appearance: none; /* Removendo estilos padrão */\n}\n  \n/* Estilizando a linha do track */\ninput[type=\"range\"]::-webkit-slider-runnable-track {\n    height: 10px;\n    border-radius: 5px;\n    background-color: rgb(36, 42, 51);\n}\n.light-form input[type=\"range\"]::-webkit-slider-runnable-track {\n    background-color: rgba($color: $color-white, $alpha: 0.2);\n}\n\n/* Estilizando o thumb (alça) do slider */\ninput[type=\"range\"]::-webkit-slider-thumb {\n    width: 20px;\n    height: 20px;\n    background-color: $color-green;\n    border-radius: 50%;\n    cursor: pointer;\n    appearance: none; /* Removendo estilos padrão */\n    margin-top: -5px; /* Ajustando a posição vertical da alça */\n}\n.light-form input[type=\"range\"]::-webkit-slider-thumb {\n    background-color: $color-green-light-1;\n}\n.dashboard-filters{\n    display: block;\n    padding-bottom: $gap-2;\n    @include responsive(xs){\n        display: block;\n    }\n    \n}\n.label-options{\n    display: flex;\n    flex-wrap: wrap;\n    label{\n        width: auto;\n        border: 1px solid rgba($color: $gray-6, $alpha: 0.8);\n        border-radius: 3px;\n        margin-right: $gap-2;\n        padding: $gap-4 $gap-2;\n        &:hover{\n            border: 1px solid $color-green;\n            background-color: rgba($color: $color-white, $alpha: 0.1);\n            cursor: pointer;\n        }\n    }\n    @include responsive(xs){\n        display: block;\n        width: 100%;\n        label{\n            margin-right: 0;\n            \n        }\n        \n    }\n\n}\n.filter-section{\n    margin-bottom: $gap-1;\n}\n.filter-section label{\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    margin-bottom: $gap-1;\n    margin-top: $gap-1;\n    height: 20px;\n    input{\n        width: 20px;\n    }\n    p{\n        padding-left: 4px;\n        color: $gray-7;\n        line-height: 14px;\n    }\n   \n}\n\n#dashboard{\n    select{\n        margin-top: $gap-1;\n        background-color: transparent;\n        color: $light-black-green;\n        border: 1px solid $color-green;\n        padding-left: $gap-2;\n    }\n}\n",".body-admin{\n    height: 100vh;\n    overflow-x: hidden;\n    display: flex;\n}\n\n.menu-admin{\n    width: 150px;\n    margin-top: 90px;\n    height: calc(100vh - 83px);\n    //background-color: rgba($color: #FFF, $alpha: 0.04);\n    position: fixed;\n    li{\n        background: none;\n        border-radius: 0px;\n        position: relative;\n        margin-bottom: 0;\n        \n        &::before {\n            content: \"\";\n            position: absolute;\n            left: $gap-2;\n            top: 50%;\n            transform: translateY(-50%);\n            width: 8px;\n            height: 8px;\n            border-radius: 50%;\n            background-color: rgba($color: $color-white, $alpha: 0.3);\n          }\n        a{\n            padding-left: $gap-5;\n            color: rgba($color: $color-white, $alpha: 0.4);\n            border-top-right-radius: 2px;\n            border-bottom-right-radius: 2px;\n            &:hover{\n                background-color:rgba($color: $color-white, $alpha: 0.4);\n                color:$color-white\n            }\n        }\n        \n    }\n    .selected{\n        &::before{\n            background-color:$color-green;\n        }\n        a{\n            color: rgba($color: $color-white, $alpha: 0.8);\n        }\n    }\n    @include responsive(s){\n        display: none;\n    }\n}\n.light .menu-admin{\n    li{\n        &::before {\n            background-color: $color-white;\n          }\n    }\n    a{\n        color: $gray-4;\n        border-top-right-radius: 2px;\n        border-bottom-right-radius: 2px;\n        &:hover{\n            background-color:rgba($color: $gray-6, $alpha: 0.4);\n            color:$light-black-green\n        }\n    }\n    .selected{\n        &::before{\n            background-color:$color-green;\n        }\n        \n    }\n}\n.actions{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    @include responsive(s){\n        display: block;\n        width: 100%;\n        .profile-actions{\n            \n            margin-top: $gap-2;\n            display: block;\n            justify-content: center;\n            align-items: center;\n    \n        }\n    }\n    @include responsive(xs){\n        .btn{\n            width: 100%;\n            margin-bottom: $gap-1;\n            p{\n                text-align: center;\n            }\n        }\n    }\n}\n\n.container-admin{\n    width: 100%;\n    padding-right: $gap-3;\n    padding-left: $gap-3;\n    padding-bottom: $gap-3;\n    margin-top: 90px;\n\n    h3{\n        color: rgba($color: $color-white, $alpha: 0.8);\n        font-weight: 300;\n    }\n    h4{\n        color: rgba($color: $color-white, $alpha: 0.8);\n        font-weight: 300;\n    }\n    .header{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        \n    }\n   \n    @include responsive(s){\n        margin-top: 70px;\n        \n        .header{\n            display: flex;\n            flex-direction: column-reverse;\n            align-items: flex-start;\n        }\n        .header h4{\n            margin-top: $gap-2;\n        }\n        \n    }\n    \n}\n.light .container-admin h4{\n    color: $light-black-green;\n}\n.container-admin-menu{\n    margin-left: 158px;\n    \n    @include responsive(s){\n        margin-left: 0;\n        \n    }\n}\n.container-profile{\n    @include responsive(s){\n        margin-top: 85px;\n        \n    }\n}\n.boxes{\n    padding-bottom: $gap-3;\n    margin-top: $gap-3;\n}\n.box{\n    width: 100%;\n    margin-bottom: $gap-2;\n    padding:$gap-2 $gap-3;\n    border: 1px solid rgba($color: $gray-6, $alpha: 0.8);\n    border-radius: 3px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    &:hover{\n        border: 1px solid $color-green;\n        background-color: rgba($color: $color-white, $alpha: 0.1);\n        cursor: pointer;\n    }\n    p{\n        color: rgba($color: $color-white, $alpha: 0.8);\n    }\n    .btn{\n        padding: $gap-1 $gap-3;\n    }\n    @include responsive(xs){\n        span{\n            display: none;\n        }\n        .box-content{\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            display: inline-block;\n            width:100%\n        }\n    }\n   \n}\n\n.light .box{\n    border: 1px solid #dcdcdc;\n    \n    &:hover{\n        border: 1px solid $light-green-2-medium;\n        background-color: rgba($color: #FFF, $alpha: 0.5);\n        cursor: pointer;\n    }\n    p{\n        color: $color-black;\n    }\n    @include responsive(xs){\n        span{\n            display: none;\n        }\n        .box-content{\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            display: inline-block;\n            width:100%\n        }\n    }\n   \n} \n#headerAdmin{\n    .logo{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        a{  \n            padding-bottom: -5px;\n        }\n        svg{ \n\n            width: 39px;\n            height: 50px;\n        }\n    }\n    @include responsive(s){\n        \n        .logo-img{\n            display: none\n        };\n        .logo-img-block{\n            display: flex;\n        }\n    }\n    \n    .title{\n        overflow: hidden;\n        padding-left: $gap-1;\n        padding-top: $gap-5;\n        @include responsive(s){\n            padding-top: 0;\n            margin-left: $gap-1;\n            padding-left: 0;\n        }\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        p{  \n            color: rgba($color: $color-white, $alpha: 0.5); \n        }\n        \n    }\n    .light {\n        p{\n            color: $light-black-green;\n        }\n    }\n}\n\n\n.header-profile{\n    @include responsive(s){\n        p{\n            padding-top: 20px;\n        }\n        svg{ \n            //width: 39px;\n            margin-top: 20px;\n            margin-bottom: 30px;\n        }\n        \n    }\n    \n}\n.nav-admin{\n    margin-top: $gap-2;\n    ul{\n        display: flex;\n        position: relative;\n        &::before {\n            content: \"\";\n            position: absolute;\n            bottom: -0.5px;\n            transform: translateY(-50%);\n            width: 100%;\n            height: 1px;\n            background-color: #909DAE;\n          }\n    }\n    li{\n        background: none;\n        border-radius: 0px;\n        position: relative;\n        margin-bottom: 0;\n        &::before {\n            content: \"\";\n            position: absolute;\n            bottom: 0;\n            width: 100%;\n            transition: all ease 0.4s ;\n          }\n        \n        &:hover{\n            &::before{\n                height: 2px;\n                background-color: $color-green;\n            }\n        }\n\n        a{\n            color: rgba($color: $color-white, $alpha: 0.4);\n            \n        }\n        \n    }\n    .selected{\n        &::before {\n            content: \"\";\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            width: 100%;\n            height: 2px;\n            background-color: $color-green;\n          }\n        \n          color: rgba($color: $color-white, $alpha: 0.8);\n        \n    }\n    \n}\n\n.success-message {\n    color: white;\n    padding: $gap-1 $gap-2;\n    border: 1px solid $color-green;\n    background-color: rgba($color: $color-white, $alpha: 1);\n}\n\n.incluir-avaliador{\n    display: flex;\n    align-items: end;\n    @include responsive(xs){\n        display: block;\n        .btn{\n            margin-left: 0;\n            margin-top: $gap-1;\n        }\n    }\n}\n.dashboard-summary{\n    display: flex;\n}\n\n.light h3{\n    color:$light-black-green;\n    font-weight: 400;\n}\n.light{\n    .avaliador {\n        @include responsive(xs){\n        .box-content{\n            overflow: visible;\n            white-space: normal;\n            display: block;\n        }}\n}}\n\n",".table{\n    width: 100%;\n    height: 300px;\n    overflow-x: scroll;\n    overflow-y: scroll;\n}\ntable {\n    border-spacing: 0;\n    color:$gray-8;\n    @include typeface-2(p2,desktop);\n    @include responsive(s){\n        @include typeface-2(p3,mobile);\n    }\n    thead{\n        background-color: rgba($color: #FFF, $alpha: 0.2);\n    }\n    th{\n        padding: 2px 16px;\n    }\n}",".message{\n    width: 100%;\n    \n}\n.error-message{\n    p{\n        color: $color-white-dark-2;\n        font-weight: 300;\n    }\n    \n    padding: 8px 18px;\n    background: rgba(255, 0, 0, 0.56);\n    border: 1px solid #F03D3D;\n    border-radius: 2px;\n}\n.light .error-message{\n    p{\n        color: #8a0101;\n    }\n    background: rgba(255, 0, 0, 0.3);\n}\n.success-message {\n    padding: $gap-1 $gap-2;\n    border: 1px solid $color-green;\n    background-color: rgba($color: $color-white, $alpha: 0.1);\n    p{\n        color: rgb(192, 192, 192);\n    }\n}",".general{\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    .col{\n        display: block;\n        flex: 1;\n        &:not(:last-child) {\n            margin-right: $gap-3; /* Adjust as needed */\n          }\n        .status{\n            width: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            h4{\n                font-size: 14px;\n                margin-right: $gap-3;\n            }\n        }\n    }\n}\n.areas{\n    \n    .status{\n        display: flex;\n        flex-wrap: wrap;\n        .box{\n            margin-right: $gap-3;\n            flex: 1;\n            width: 100%;\n            h4{\n                color:red;\n                display: block;\n                width: auto;\n            }\n        }\n    }\n\n}\n.areas .box{\n    \n    \n        h4{\n            font-size: 14px;\n            //margin-right: $gap-3;\n        }\n  \n    border: 1px solid $auxiliary-red-extralight;\n    flex: 1;\n}\n\n.posters, .posters-list{\n    display: flex;\n    width: 100%;\n    overflow-y: scroll;\n    .poster, .item{\n        border: 1px solid $color-green;\n        border-radius: 3px;\n        padding: 4px 6px;\n        margin:4px\n    }\n}\n.legenda{\n    height: auto;\n}\n.reservado{\n    background-color: none;\n}\n.conflito{\n    background-color: $auxiliary-red-extralight;\n}\n.aguardando{\n    background-color: $auxiliary-yellow-light;\n}\n.emAvaliacao{\n    background-color: $light-green-2-medium;\n}\n.posters{\n    flex-wrap: wrap;\n}\n.posters-list {\n    width: auto;\n    height: auto;\n}\n.vazio{\n    select{\n        width: 160px;\n    }\n    margin-top: $gap-2;\n}\n\n#dashboard input{\n    color: $light-black-green;\n    &::placeholder{\n        color: $gray-6; \n    }\n}\n\n.container-dashboard{\n    max-width: 850px;\n}","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500&display=swap');\n\n.certificado-body{\n    height: 100vh;\n    background-color: #EDF2F2;\n    justify-content: left;\n    align-items: start;\n    border: 1px solid #818181;\n    h4{\n        font-family: 'Inter', sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        color: $light-black-green;\n    }\n    p{\n        line-height: 19px;\n    }\n    .header{\n        height: 160px;\n        width: 100%;\n        background-color: #FFF;\n        display: flex;\n        justify-content: left;\n        align-items: center;\n        padding: 40px;\n        svg{\n            height: 114px;\n            width: auto;\n            margin-right: 18px;\n        }\n        .title{\n            display: flex;\n            align-items: center;\n            margin-top: 60px;\n            p{\n                margin-left: $gap-4;\n                border-left: 2px solid $color-green;\n                padding: 10px;\n            }\n        }\n    }\n    .section{\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        height: calc(100vh - 200px);\n    }\n    .content{\n        padding: 40px;\n        max-width: 800px;\n        \n        h4{\n            font-size: 40px;\n            margin-bottom: 20px;\n            font-family: 'Inter', sans-serif;\n        }\n        p{\n            font-weight: 300;\n        }\n        p,span{\n            font-size: 16px;\n            font-family: 'Inter', sans-serif;\n        }\n        span{\n            font-weight: 500;\n        }\n        .autenticacao{\n            margin-top: 40px;\n            display: flex;\n            p{\n                font-size: 12px;\n                margin-top: 8px;\n                line-height: 14px;\n            }\n            span{\n                margin-left: 10px;\n                line-height: 12px;\n                font-size: 16px;\n                font-family: 'Inter', sans-serif;\n            }\n        }\n    }\n    .footer{\n        padding:0 40px;\n        svg{\n            height: 30px;\n            width: auto;\n            margin-right: 20px;\n            margin-bottom: 20px;\n        }\n        div{\n            display: flex;\n            flex-wrap:nowrap;\n            align-items: center;\n            justify-content: left;\n        }\n       \n    }\n}\n\n\n@media print{\n        .certificado-body{\n            \n            box-shadow: 0 0 0 1000px #EDF2F2 inset;  /* cor para impressão */\n        }\n        \n    \n}",".avaliador{\n    .logo h3{\n        background-color:$light-green-2-medium;\n        font-size: 14px;\n        width: 100%;\n        padding: 8px 16px;\n        text-align: center;\n        border-radius: 4px;\n        color: $light-black-green;\n    }\n    select{\n        color: $light-black-green;\n    }\n}","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500&display=swap');\n\n.resumosHtml-body{\n    \n    .page-break {\n        page-break-before: always; /* ou page-break-after: always; */\n      }\n    background-color: #FFF;\n    justify-content: left;\n    align-items: start;\n    border: 1px solid #818181;\n    h4{\n        font-family: 'Inter', sans-serif;\n        font-size: 12px;\n        font-weight: 500;\n        color: $light-black-green;\n    }\n    p,span{\n        line-height: 19px;\n        font-size: 12px;\n    }\n    .header{\n        height: 160px;\n        width: 100%;\n        background-color: #FFF;\n        display: flex;\n        justify-content: left;\n        align-items: center;\n        padding: 40px;\n        svg{\n            height: 114px;\n            width: auto;\n            margin-right: 18px;\n        }\n        .title{\n            display: flex;\n            align-items: center;\n            margin-top: 60px;\n            p{\n                margin-left: $gap-4;\n                border-left: 2px solid $color-green;\n                padding: 10px;\n            }\n        }\n    }\n    .resumos{\n        max-width: 600px;\n        margin-left: auto;\n        margin-right: auto;\n        margin-top:$gap-4;\n        margin-bottom:$gap-4;\n        h4{\n            margin-bottom: $gap-2;\n        }\n    }\n    .section{\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        height: calc(100vh - 200px);\n    }\n    .content{\n        padding: 40px;\n        max-width: 800px;\n        \n        h4{\n            font-size: 40px;\n            margin-bottom: 20px;\n            font-family: 'Inter', sans-serif;\n        }\n        p{\n            font-weight: 300;\n        }\n        p,span{\n            font-size: 10px;\n            font-family: 'Inter', sans-serif;\n        }\n        span{\n            font-weight: 500;\n        }\n        .autenticacao{\n            margin-top: 40px;\n            display: flex;\n            p{\n                font-size: 10px;\n                margin-top: 8px;\n                line-height: 14px;\n            }\n            span{\n                margin-left: 10px;\n                line-height: 12px;\n                font-size: 10px;\n                font-family: 'Inter', sans-serif;\n            }\n        }\n    }\n    .footer{\n        padding:0 40px;\n        svg{\n            height: 30px;\n            width: auto;\n            margin-right: 20px;\n            margin-bottom: 20px;\n        }\n        div{\n            display: flex;\n            flex-wrap:nowrap;\n            align-items: center;\n            justify-content: left;\n        }\n       \n    }\n}\n\n\n@media print{\n        .certificado-body{\n            \n            box-shadow: 0 0 0 1000px #EDF2F2 inset;  /* cor para impressão */\n        }\n        .no-print {\n            display: none !important;\n          }\n        \n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
